import React, { useEffect, useState,useContext,useRef } from 'react';
import AppContext from "../AppContext"
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Row,Divider,Col,Space,Modal,Form,Select,Input,Upload,Button,Collapse,message,Typography,List, Popconfirm, Table,Image } from 'antd';
import { UploadOutlined,  FileOutlined} from "@ant-design/icons";
import moment from 'moment';
import { GetTranslation } from '../../Models/shared/general';
import Autocomplete from '@mui/material/Autocomplete';
import { experimentalStyled as styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Unstable_Grid2';
import Badge from '@mui/material/Badge';
import VirtualList from 'rc-virtual-list';
import DoneIcon from '@mui/icons-material/Done';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import AlarmIcon from '@mui/icons-material/Alarm';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import Backdrop from '@mui/material/Backdrop';
import { printToPreview } from '../../Controller/FilePreview';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import HistoryIcon from '@mui/icons-material/History';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CollapseMUI from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import TableMUI from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { DataGrid } from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import ListSubheader from '@mui/material/ListSubheader';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

import CircularProgress from '@mui/material/CircularProgress';
import EditIcon from '@mui/icons-material/Edit';
import { getAllUserLists } from '../../Controller/Management/UserProf_Ctrl';
import {onCreatePayment,
        onLoadPayment,
        onLoadPaymentAcct,
        onLoadPayeeActive,
        onLoadPaytype,
        onLoadAccoutItems,
        onUpdatePayment,
        onCreateTemplate,
        onLoadTemplate,
        onUpdateTemplate,
        onCreatePaymentByTemplate,
        onLoadPaymentByPayee
    } from '../../Controller/Management/PaymentManagement'
import Checkbox from 'antd/lib/checkbox/Checkbox';
import { calculatePinnedRowsHeight } from '@mui/x-data-grid/hooks/features/rows/gridRowsUtils';
import { onCreateAttachment } from '../../Controller/Chat';

export default function PaymentListing(prop) {

    const XLSX = require('xlsx')
    const EditableContext                                       = React.createContext(null);
    const EditableRow = ({ index, ...props }) => {
        const [form] = Form.useForm();
        return (
          <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
              <tr {...props} />
            </EditableContext.Provider>
          </Form>
        );
      };
    const [selectionType, setSelectionType]                     = useState('checkbox');
    const global                                                = useContext(AppContext)
    const userid                                                = global.UserIdentity.userid;
    const username                                              = global.UserIdentity.username;
    const globaldepartment                                      = global.UserIdentity.department;
    const globalgrouping                                        = global.UserIdentity.grouping;
    const [FULLuserLists, setFULLUserLists]                     = useState([]);
    const [FULLtemplte, setFULLtemplte]                         = useState([]);
    const { Panel }                                             = Collapse;

    const { Text, Paragraph }                                   = Typography;
    const [collapse, setCollapse]                               = useState([1]); // SET IS COLLAPSE
    const [form]                                                = Form.useForm();

    const { Option }                                            = Select;
    const { TextArea, Search }                                  = Input;
    const [currentstatus,setcurrentstatus]                      = useState(-3)
    const [currentfilter,setcurrentfilter]                      = useState("create")
    const [datasource,setdatasource]                            = useState([]);
    const [datasourceByStatus,setdatasourceByStatus]            = useState([]);
    const [datasourceDetail,setdatasourceDetail]                = useState([]);
    const [datasourceDetail2,setdatasourceDetail2]              = useState([]);
    const [datasourceDetailHeader,setdatasourceDetailHeader]    = useState([]);
    const [datasourceHistrory,setdatasourceHistrory]            = useState([]);
    const [datasourceDetailTotal, setdatasourceDetailTotal]     = useState(0); 
    const [Mpaymentacct, setMpaymentacct]                       = useState();
    const [Mpayee, setMpayee]                                   = useState();
    const [Mpaytype, setMpaytype]                               = useState();
    const [Maccoutitems, setMaacountitems]                      = useState()
    const [SBankCurrencyDisable, setSBankCurrencyDisable]       = useState(true)
    const [dayjsdate, setdayjsdate]                             = useState(); 
    const [Fmonth, setFmonth]                                   = useState("ALL"); 
    const [Ftype, setFtype]                                     = useState("Active");
    const [Otypelist, setOtypelist]                             = useState([{label:"sample1",value:"sample1"}]); 
    // Create Data listing
    const [CheaderData, setCheaderData]                         = useState("")
    const [Ctitle, setCtitle]                                   = useState(""); 
    const [Cdatalist, setCdatalist]                             = useState([]);
    const [Cinvdate, setCinvdate]                               = useState(""); 
    const [Cbankacct, setCbankacct]                             = useState("");
    const [Cpayacctdesc, setCpayacctdesc]                       = useState("");  
    const [Csupplierid, setCsupplierid]                         = useState(""); 
    const [Csupplier, setCsupplier]                             = useState(""); 
    const [Csupplierdesc, setCsupplierdesc]                     = useState(""); 
    const [Cbank, setCbank]                                     = useState(""); 
    const [Ccurrency, setCcurrency]                             = useState(""); 
    const [Cdetail, setCdetail]                                 = useState("");
    const [Ctype, setCtype]                                     = useState("CLAIM") 
    const [Camount, setCamount]                                 = useState(0); 
    const [Ctotal, setCtotal]                                   = useState(0); 
    const [Cremark, setCremark]                                 = useState(""); 
    const [Cdetailitemslist, setCdetailitemslist]               = useState([]); 
    const [Cdetailitemsheader, setCdetailitemsheader]           = useState("Detail Items")
    const [Cfilelist, setCfilelist]                             = useState([]); 
    const [Ctemplist, setCtemplist]                             = useState([]); 
    const [Cdetailfilelist, setCdetailfilelist]                 = useState([]); 
    // Create Data listing

    // Detail Data listing
    const [Ditemtype, setDitemtype]                             = useState("")
    const [DitemtypeID, setDitemtypeID]                         = useState("")
    const [Ddescription, setDdescription]                       = useState("")
    const [Dqty, setDqty]                                       = useState(0)
    const [Dpriceunit, setDpriceunit]                           = useState(0)
    const [Dtotalqty, setDtotalqty]                             = useState(0)
    const [Dtotalprice, setDtotalprice]                         = useState(0)
    // Detail Data listing
    const [DetailAttachHeader,setDetailAttachHeader]            = useState()
    const [previewIconVisible, setPreviewIconVisible]           = useState(false);
    const [previewbankacctinput, setpreviewbankacctinput]       = useState(true);
    const [CurrentCreateDetailID,setCurrentCreateDetailID]      = useState()
    const [CurrentDetailType,setCurrentDetailType]              = useState("create")
    const [CurrentEditID, setCurrentEditID]                     = useState("")
    const [CurrentFirstDay, setCurrentFirstDay]                 = useState("")
    const [CurrentLastDay, setCurrentLastDay]                   = useState("")
    const [CurrentPaymentacct, setCurrentPaymentacct]           = useState("")
    const [CurrentTotalAmount, setCurrentTotalAmount]           = useState(0)
    const [previewDetailFileList, setPreviewDetailFileList]     = useState(false);

    const [previewDetailFileList2, setPreviewDetailFileList2]   = useState(false);
    const [previewIconImage, setPreviewIconImage]               = useState('');
    //

    const [ActionCheckList,setActionCheckList]                  = useState([])
    const [ButtonDisable,setButtonDisable]                      = useState(true)
    const [ButtonTemplateDisable,setButtonTemplateDisable]      = useState(true)
    const [ButtonPaydateDisable,setButtonPaydateDisable]        = useState(false)
    const [Tinvdate, setTinvdate]                               = useState(""); 
    const [Ipaydate, setIpaydate]                               = useState(""); 
    const [Ipayid, setIpayid]                                   = useState(""); 

    const [modalVisiblePayCreate, setmodalVisiblePayCreate]     = useState(false);
    const [modalVisibleHistory, setmodalVisibleHistory]         = useState(false);
    const [modalHistoryHeader, setmodalHistoryHeader]           = useState('')
    const [modalVisibleDetailList, setmodalVisibleDetailList]   = useState(false);
    const [opendialog,setopendialog]                            = useState(false)
    const [openUpdatedialog,setopenUpdatedialog]                = useState(false)
    const [dialogtitle,setdialogtitle]                          = useState("")
    const [dialogUpdateDetailCount,setdialogUpdateDetailCount]  = useState(0)
    const [dialogUpdateDetailAmount,setdialogUpdateDetailAmount]= useState(0)
    const [dialogUpdateDetailStatus,setdialogUpdateDetailStatus]= useState("")
    const [dialogUpdatedetailbutton,setdialogUpdatedetailbutton]= useState("")
    const [opensnacksuccess,setopensnacksuccess]                = useState(false)
    const [opensnackfail,setopensnackfail]                      = useState(false)
    const [opensnackerror,setopensnackerror]                    = useState(false)
    const [opensnackupdate,setopensnackupdate]                  = useState(false)
    const [CheckAllIndeterminate,setCheckAllIndeterminate]      = useState(false)
    const [CheckAllchecked,setCheckAllchecked]                  = useState(false)
    const [CheckAlldisable,setCheckAlldisable]                  = useState(true)
    const userlang                                              = navigator.language || navigator.userLanguage;
    const [yearvalue, setyearvalue]                             = useState(dayjs());

    const [CountActive,setCountActive]                          = useState(0)
    const [UnreadActive,setUnreadActive]                        = useState(0)
    const [CountSelf,setCountSelf]                              = useState(0)
    const [UnreadSelf,setUnreadSelf]                            = useState(0)
    const [CountRejected,setCountRejected]                      = useState(0)
    const [UnreadRejected,setUnreadRejected]                    = useState(0)
    const [CountWaitApproval,setCountWaitApproval]              = useState(0)
    const [UnreadWaitApproval,setUnreadWaitApproval]            = useState(0)
    const [CountWaitVerify,setCountWaitVerify]                  = useState(0)
    const [UnreadWaitVerify,setUnreadWaitVerify]                = useState(0)
    const [CountWaitIssue,setCountWaitIssue]                    = useState(0)
    const [UnreadWaitIssue,setUnreadWaitIssue]                  = useState(0)
    const [CountCompleted,setCountCompleted]                    = useState(0)
    const [UnreadCompleted,setUnreadCompleted]                  = useState(0)
    const [CountCancel,setCountCancel]                          = useState(0)
    const [UnreadCancel,setUnreadCancel]                        = useState(0)
    const [CountExport,setCountExport]                          = useState(0)
    const [UnreadExport,setUnreadExport]                        = useState(0)
    const [CountDone,setCountDone]                              = useState(0)
    const [UnreadDone,setUnreadDone]                            = useState(0)

    const [ProgressStatus, setPogressStatus]                    = useState(true);
    const [payidselect, setpayidselect]                         = useState([]);
    const monthselect = [
        {label : "ALL", value : "ALL"},
        {label : "JAN", value : "JAN"},
        {label : "FEB", value : "FEB"},
        {label : "MAR", value : "MAR"},
        {label : "APR", value : "APR"},
        {label : "MAY", value : "MAY"},
        {label : "JUN", value : "JUN"},
        {label : "JUL", value : "JUL"},
        {label : "AUG", value : "AUG"},
        {label : "SEP", value : "SEP"},
        {label : "OCT", value : "OCT"},
        {label : "NOV", value : "NOV"},
        {label : "DEC", value : "DEC"},
    ]
    const bankselect = [
        {label : "ALLIANCE BANK", value : "ALLIANCE BANK"},
        {label : "AMBANK", value : "AMBANK"},
        {label : "CIMB", value : "CIMB"},
        {label : "FPX", value : "FPX"},
        {label : "HONG LEONG BANK", value : "HONG LEONG BANK"},
        {label : "HSBC", value : "HSBC"},
        {label : "JOMPAY", value : "JOMPAY"},
        {label : "MAYBANK", value : "MAYBANK"},
        {label : "OCBC", value : "OCBC"},
        {label : "PUBLIC BANK", value : "PUBLIC BANK"},
        {label : "RHB", value : "RHB"}
    ]
    const currencyselect = [
        {label : "MYR", value : "MYR"},
        {label : "USD", value : "USD"},
        {label : "THB", value : "THB"},
        {label : "USDT", value : "USDT"},
      ]

    const paymenttypeselect = [
        {label : "CLAIM", value : "CLAIM"},
        {label : "ONCE OFF", value : "ONCE OFF"},
        {label : "MONTHLY", value : "MONTHLY"},
        {label : "QUARTERLY", value : "QUARTERLY"},
        {label : "YEARLY", value : "YEARLY"},
    ]

    const userverifylist        = ['60ebf3b2e0741b107ce0d8a6','60eba6f748c6fe1a99ce6994']
                                    //Bee                       Lucas
    const userissuelist         = ['60ebf1d6aebe39153046d6d6','60eba6f748c6fe1a99ce6994']
                                    //Waibein                   Lucas
    const usercompletelist      = ['60ebde816d150ba31d16a879','60eba6f748c6fe1a99ce6994']
                                    //Nicholas                  Lucas
    const userexportlist        = ['60ebf3b2e0741b107ce0d8a6','60ebf1d6aebe39153046d6d6','60eba6f748c6fe1a99ce6994']
                                    //Bee                       Waibein                    Lucas

    var winheight = window.innerHeight;

    const paybankacctselect = [
        {label : "CIMB(MYR) 8010778536", value : "310-CIMB1",currency:"MYR"},
        {label : "CIMB(USD)", value : "310-CIMB2",currency:"USD"},
        {label : "OCBC(MYR) 705-131595-2", value : "310-OCBC1",currency:"MYR"},
        {label : "OCBC(USD) 705-133665-8", value : "310-OCBC2",currency:"USD"},
        {label : "OCBC A/C (PEGASUS @ USD)", value : "312-000",currency:"USD"},
        {label : "USDT", value : "317-000",currency:"USDT"}
    ]
    const filterselect = [
        {label : "Active", value : "Active"},
        {label : "Approved", value : "Approved"},
        {label : "Rejected", value : "Rejected"},
        {label : "Canceled", value : "Canceled"},
        {label : "Verified", value : "Verified"},
        {label : "ALL", value : "ALL"}
    ]
   
    const supplierdata = [
        {label:"Supp A",value:"Supp A",suppid : "Supp A", currency :"MYR",bank : "Maybank"}
    ]
    function subtotal(items) {
        
        return items.map(({ Damount }) => Damount).reduce((sum, i) => sum + i, 0);
    }

    function subtotalqty(items) {
        
        return items.map(({ Dqty }) => Dqty).reduce((sum, i) => sum + i, 0);
    }

    function subtotaldetailprice(items) {
        
        return items.map(({ Dtotalprice }) => Dtotalprice).reduce((sum, i) => sum + i, 0);
    }
    

    const onTemplateChange = (info) => {
        console.log("FULLtemplte >>>>",FULLtemplte)
        let newFileList = [...info.fileList];
        let index = 0
        if(newFileList && newFileList.length > 0 && newFileList.length >= Cfilelist.length){
            for (var i = 0; i < newFileList.length; i++) {
                let src = info.url;
                if(!src){
                    return new Promise(resolve => {
                        const reader = new FileReader();
                        reader.readAsDataURL(info.file);
                        reader.onload = () => resolve(reader.result);
                    }).then(src => {
                        //let index   = newFileList.findIndex(x => x.originFileObj == info.file);
                        index=i
                       // console.log("index",index)
                       // console.log("i",i)
                       // console.log("newfilelistlength",newFileList.length)
                        newFileList[index].preview = src;
                        console.log("newFileList",newFileList)
                        setCfilelist(newFileList);
                        
                    })
                }
            }
        }
        else{
            setCfilelist(newFileList)
        }
        
    }

    const onFileChange = (info) => {
        console.log("FULLtemplte >>>>",FULLtemplte)
        let newFileList = [...info.fileList];
        let index = 0
        if(newFileList && newFileList.length > 0 && newFileList.length >= Cfilelist.length){
            for (var i = 0; i < newFileList.length; i++) {
                let src = info.url;
                if(!src){
                    return new Promise(resolve => {
                        const reader = new FileReader();
                        reader.readAsDataURL(info.file);
                        reader.onload = () => resolve(reader.result);
                    }).then(src => {
                        //let index   = newFileList.findIndex(x => x.originFileObj == info.file);
                        index=i
                       // console.log("index",index)
                       // console.log("i",i)
                       // console.log("newfilelistlength",newFileList.length)
                        newFileList[index].preview = src;
                        console.log("newFileList",newFileList)
                        setCfilelist(newFileList);
                        
                    })
                }
            }
        }
        else{
            setCfilelist(newFileList)
        }
        
    }
    const onDetailFileChange = (info) => {
        console.log("info >>>>",info)
        let newFileList = [...info.fileList];
        let index = 0
        if(newFileList && newFileList.length > 0 && newFileList.length >= Cfilelist.length){
            for (var i = 0; i < newFileList.length; i++) {
                let src = info.url;
                if(!src){
                    return new Promise(resolve => {
                        const reader = new FileReader();
                        reader.readAsDataURL(info.file);
                        reader.onload = () => resolve(reader.result);
                    }).then(src => {
                        //let index   = newFileList.findIndex(x => x.originFileObj == info.file);
                        index=i
                       // console.log("index",index)
                       // console.log("i",i)
                       // console.log("newfilelistlength",newFileList.length)
                        newFileList[index].preview = src;
                       // console.log("newFileList",newFileList)


                        setCdetailfilelist(newFileList);
                    
                        let newds                   = Cdatalist;
                        let newindex                = Cdatalist.findIndex(x => x.Did == CurrentCreateDetailID);
                    
                        if(newindex != undefined && newindex != null)
                        {
                            newds[newindex].Dfilelist    = newFileList;
                            setCdatalist(newds)
                        }
                    })
                }
            }
        }
        else{
            setCdetailfilelist(newFileList)
            let newds                   = Cdatalist;
            let newindex                = Cdatalist.findIndex(x => x.Did == CurrentCreateDetailID);
        
            if(newindex != undefined && newindex != null)
            {
                newds[newindex].Dfilelist    = newFileList;
                setCdatalist(newds)
            }
        }


        
    }

    const handleIconPreview = (info) => {
    
        if(info.type.includes("image")){   
            setPreviewIconImage(info.preview)
            setPreviewIconVisible(true)
        }
        else{
            printToPreview({ b64Data: info.preview, type: info.type })
        }
    }
    const handleIconPreviewCancel = () => {
        setPreviewIconVisible(false)
    }

    const handleDetailCancel = () => {
        setPreviewDetailFileList(false)
        setmodalVisiblePayCreate(true)
    }

    const handleDetailCancel2 = () => {
        setPreviewDetailFileList2(false)
        setmodalVisibleDetailList(true)
    }

    const PaymentAttProps = {
       
        listType    : "picture",
        fileList    : Cfilelist,
        accept      : ".png,.jpeg,.jpg,.pdf,.xls",
        multiple    : true,
        beforeUpload: (file) => {    
            return false;
        },
        onChange    : onFileChange,
        onPreview   : handleIconPreview
    };

    const TemplateAttProps = {
       
        listType    : "picture",
        fileList    : Ctemplist,
        accept      : ".png,.jpeg,.jpg,.pdf,.xls",
        multiple    : true,
        beforeUpload: (file) => {    
            return false;
        },
        onChange    : onTemplateChange,
        onPreview   : handleIconPreview
    };

    const PaymentDetailAttProps = {
       
        listType    : "picture",
        fileList    : Cdetailfilelist,
        accept      : ".png,.jpeg,.jpg,.pdf,.xls",
        multiple    : true,
        beforeUpload: (file) => {    
            return false;
        },
        onChange    : onDetailFileChange,
        onPreview   : handleDetailCancel
    };

    const Item = styled(Paper)(({ theme }) => ({
       // backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : 'rgb(240,242,245)',
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
       ...theme.typography.body2,
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
      }));


    function addCreateListing()
    {
        var newlist = Cdatalist;
        var obj = {};

        // if(Cpayacct == undefined || Cpayacct == null || Cpayacct == '')
        // {
        //     message.error("Please Select Payment Account !!")
        //     return
        // }
        // if(Csupplier == undefined || Csupplier == null || Csupplier == '')
        // {
        //     message.error("Please Select Supplier !!")
        //     return
        // }
        // if(Ctype == undefined || Ctype == null || Ctype == '')
        // {
        //     message.error("Please Select or Key in Type !!")
        //     return
        // }
        // if(Camount == undefined || Camount == null || Camount == '0')
        // {
        //     message.error("Please key in correct amount !!")
        //     return
        // }
        console.log("Cinvdate >>>>",Cinvdate)
        obj["Did"]          = newlist.length ? newlist.length : 0
        obj["Dsupplier"]    = Csupplier
        obj["Dbank"]        = Cbank
        obj["Dtype"]        = Ctype 
        obj["Ddetail"]      = Cdetail
        obj["Damount"]      = parseFloat(Camount)
        obj["Dremarks"]     = Cremark
        obj["Dfilelist"]    = Cfilelist
        newlist.push(obj)
        
        setCfilelist([])
        setCdatalist(newlist)
        const invoiceTotal = subtotal(newlist);
        setCtotal(invoiceTotal)

        console.log("newlist >>>>",newlist)
        console.log("Cdatalist >>>>",Cdatalist)
        console.log("Cfilelist >>>",Cfilelist)
        setCheaderData("(" + newlist.length + ") Records")
    }

    function addDetailListing()
    {
        var newlist = Cdetailitemslist;
        var obj = {};

        // if(Cpayacct == undefined || Cpayacct == null || Cpayacct == '')
        // {
        //     message.error("Please Select Payment Account !!")
        //     return
        // }
        // if(Csupplier == undefined || Csupplier == null || Csupplier == '')
        // {
        //     message.error("Please Select Supplier !!")
        //     return
        // }
        // if(Ctype == undefined || Ctype == null || Ctype == '')
        // {
        //     message.error("Please Select or Key in Type !!")
        //     return
        // }
        // if(Camount == undefined || Camount == null || Camount == '0')
        // {
        //     message.error("Please key in correct amount !!")
        //     return
        // }

        obj["Did"]              = newlist.length ? newlist.length : 0
        obj["Ditemtype"]        = Ditemtype
        obj["DitemID"]          = DitemtypeID
        obj["Ddescription"]     = Ddescription
        obj["Dqty"]             = parseFloat(Dqty)
        obj["Dpriceunit"]       = parseFloat(Dpriceunit) 
        obj["Dtotalprice"]      = parseFloat(Dqty) * parseFloat(Dpriceunit) 
        obj["Dstatus"]          = 1
        newlist.push(obj)
        
        setCdetailitemslist([...newlist])
        const totalqty = subtotalqty(newlist);
        const totalprice = subtotaldetailprice(newlist);
        if(CurrentDetailType == "create" ||CurrentDetailType == "edit" )
        {
            setDtotalqty(totalqty)
            setDtotalprice(totalprice)
            setCdetailitemsheader(newlist.length+" Items, "+totalprice.toLocaleString(undefined, {maximumFractionDigits:2}))
        }
        else
        {
            setDtotalqty(0)
            setDtotalprice(0)
            setCdetailitemsheader("Detail Items")
       
        }
     
    }
    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      }

    async function CreatePayment(e)
    {
        if(e != 3)
        {
            if(Cdetail.length < 1)
            {
                message.error("Please Key in Description !!")
                return
            }
    
            if(Cdetailitemslist.length < 1)
            {
                message.error("Please Key in Item !!")
                return
            }
    
            if(Cinvdate == undefined || Cinvdate == null || Cinvdate == '')
                {
                    message.error("Please Select Invoice Date !!")
                    return
                }
           
            if(Ctype != 'CLAIM')
            {
                if(Csupplier == undefined || Csupplier == null || Csupplier == '')
                {
                    message.error("Please Select Payee !!")
                    return
                }
    
                if(Cbank == undefined || Cbank == null || Cbank == '')
                {
                    message.error("Please Select Bank Type !!")
                    return
                }
    
                if(Cbankacct == undefined || Cbankacct == null || Cbankacct == '')
                {
                    message.error("Please Key In Bank Acct !!")
                    return
                }
            }
            
        }
        
      

        setPogressStatus(true)
        
        let title2 = Cdetail
        let title1 = title2.toString().substr(0, 100).trim();
        var lines1 = title1.split('\n');
        let Ctitle = lines1[0].substr(0, 100).trim();

        var newpayee = 0
        if(previewbankacctinput == false)
        {
            newpayee = 1
        }
       
        let value = {
            payid           : "",
            invdate         : moment(Cinvdate.$d).unix(),
            paymentacct     : "",
            title           : Ctitle,
            description     : Cdetail,
            payeeid         : Csupplierid,
            payee           : Csupplier,
            payeedesc       : Csupplierdesc,
            banktype        : Cbank,
            bankacct        : Cbankacct,
            bankcurrency    : Ccurrency,
            paytype         : Ctype,
            detailitems     : Cdetailitemslist,
            totalamount     : Dtotalprice,
            totalqty        : Dtotalqty,
            remarks         : Cremark,
            attachments     : "",
            status          : 0,
            exported        : 0,
            paydate         : "",
            createdby       : userid,
            createddate     : moment().unix(),
            approvedby      : "",
            approveddate    : 0,
            verifyby        : "",
            verifydate      : 0,
            issueby         : "",
            issuedate       : 0,
            completedby     : "",
            completeddate   : 0,
            exportedby      : "",
            exporteddate    : 0,
            issueby         : "",
            issuedate       : 0,
            rejectby        : "",
            rejectdate      : 0,
            canceldate      : 0,
            cbunread        : 0,
            apunread        : 1,
            veunread        : 1,
            isunread        : 1,
            cpunread        : 1,
            newpayee        : newpayee,
            filepath        : ''
        }

        if(e == 0)
        {
            var date = new Date(), y = Cinvdate.$y, m = Cinvdate.$M;
            var firstDay
            var lastDay
            firstDay = new Date(y, m, 1);
            lastDay = new Date(y, m+1, 0);
           
    
            let templist = datasource.filter(x => x.ptype == Ctype && x.pdate >= dayjs(firstDay).unix() && x.pdate <= dayjs(lastDay).unix() )
    
            if(templist.length > 0)
            {
             
                setopendialog(true)
                setdialogtitle(templist.length)
                return
            }
        }
        else if(e == 1)
        {
           
            if(Cfilelist.length > 0)
            {
                var fileresult = await onCreateAttachment(Cfilelist)
                if(fileresult.data && fileresult.data != undefined && fileresult.data.length > 0)
                {
                    var path            = fileresult.data;
                    value.filepath     = path.map(x => x.filepath).toString();
                }
            }
          
            if(CurrentDetailType == "create")
            {

                
                var result = await onCreatePayment(value)
                if(result.status == "ok")
                {

                    setopendialog(false)
                    setopensnacksuccess(true)
                    
                }
                else
                {
                    setopensnackerror(true)
                }

                // onCreatePayment(value)
                // .then(updateval => {
        
                //     setopendialog(false)
                //     setopensnacksuccess(true)

                //     setCurrentDetailType("create")
                //     setCurrentEditID("")
                    
                  
                // }).catch(err => {
                //     message.error("Failed to create payment");
                    
                //     console.log("error",err)
                //             });
            }
            else if(CurrentDetailType == "edit")
            {
                value.id = [CurrentEditID]

                var result = await onUpdatePayment(value)
                if(result.status == "ok")
                {

                    setopendialog(false)
                    setopensnacksuccess(true)

                    
                }
                else
                {
                    setopensnackerror(true)
                }
            //     onUpdatePayment(value)
            //     .then(updateval => {
        
                  
            //     }).catch(err => {
                  
                   
            //         console.log("error",err)
            //                 });
            // }
            }
        }
        else if(e == 2)
        {
            
           
           var result = await onCreateTemplate(value)

           if(Cfilelist.length > 0)
           {
               var fileresult = await onCreateAttachment(Cfilelist)
               if(fileresult.data && fileresult.data != undefined && fileresult.data.length > 0)
               {
                   var path            = fileresult.data;
                   value.filepath     = path.map(x => x.filepath).toString();
               }
           }

            if(CurrentDetailType == "create")
            {
                var result2 = await onCreatePayment(value)
                if(result2.status == "ok")
                {
                    setopendialog(false)
                    setopensnacksuccess(true)

                   
                    
                }
                else
                {
                    setopensnackerror(true)
                }
                // onCreatePayment(value)
                // .then(updateval => {
        
                //     setopendialog(false)
                //     setopensnacksuccess(true)

                //     setCurrentDetailType("create")
                //     setCurrentEditID("")
                    
                   
                // }).catch(err => {
                //     message.error("Failed to create payment");
                   
                //     console.log("error",err)
                //             });
            }
            else if(CurrentDetailType == "edit")
            {
                value.id = [CurrentEditID]

                var result = await onUpdatePayment(value)
                if(result.status == "ok")
                {

                    setopendialog(false)
                    setopensnacksuccess(true)
                    
                }
                else
                {
                    setopensnackerror(true)
                }
                // onUpdatePayment(value)
                // .then(updateval => {
        
                //     setopendialog(false)
                //     setopensnacksuccess(true)

                //     setCurrentDetailType("create")
                //     setCurrentEditID("")
                   
                // }).catch(err => {
                //     message.error("Failed to create payment");
                    
                //     console.log("error",err)
                //             });
            }
           
        }
        else if(e == 3)
        {

            console.log("ActionCheckList >>>>",ActionCheckList)
            console.log("Tinvdate >>>",moment(Tinvdate.$d).unix())
            var result = await onCreatePaymentByTemplate(ActionCheckList,moment(Tinvdate.$d).unix())
         
            if(result.status == "ok")
            {
                setopendialog(false)
                setopensnacksuccess(true)

            }
            else
            {
                setopensnackerror(true)
            }
            
        }
        setActionCheckList([])
        setCurrentDetailType("create")
        setCurrentEditID("")
        LoadPaymentListing(CurrentFirstDay,CurrentLastDay)
        LoadFullTemplate()
        setPogressStatus(false)
       
    }

    //====== ATTACHMENT ======
    const showAttachmentList = (item) => {
       
        if(item.filepath != undefined && item.filepath != ""){
            return item.filepath.split(',').map(filepath => {
                var ext = filepath.split('.').pop();
                let img = ["png", "jpeg", "jpg"];
                if(img.filter(x => x == ext).length > 0){
                    return ( 
                        <>
                            <Image
                                width   ={200}
                                //src     ={`https://qc9sk2.glivestreaming.com${filepath}`}
                                src     ={`/Applications/MAMP/htdocs/Web_Projects/naxgoadmin/API/src${filepath}`}
                            >
                            </Image>
                        </>
                    )
                }
                else{
                    // ======= OTHER FILE ========
                    let filename    = filepath.split('/');
                    return (
                        <>
                           
                                <FileOutlined /> {filename[filename.length - 1]}
                                <Button style={{marginLeft: "10px"}}>
                                    {/* <a href={`https://qc9sk2.glivestreaming.com${filepath}`} target="_blank" > */}
                                    <a href={`/Applications/MAMP/htdocs/Web_Projects/naxgoadmin/API/src${filepath}`} target="_blank" >
                                        {GetTranslation(userlang, "Open")}
                                    </a>
                                </Button>
                            
                        </>
                    )
                }
            });
        }
        else{
            return (
                <>
                </>
            )
        }
    }
    async function UpdatePaymentStatus(statuscode,buttontext,checkcode,tempid,tempdata)
    {
        let newds                   = datasource;
        let newindex         
        setopenUpdatedialog(false)
        setPogressStatus(true)
        if(checkcode == 0)
        {

            let temptotalamount         = 0
            ActionCheckList.forEach(function(items)
                {
                //    if(statuscode == 8 || statuscode == 4)
                //    {
                //        if(currentstatus == 3)
                //        {
                //            let temppayidlist                = datasource.filter(x => x.payid == items);
                //            temppayidlist.forEach(function(items1)
                //            {
                //             if(items1.totalamount != undefined)
                //             {
                //                 temptotalamount = temptotalamount + items1.totalamount
                //              }
                //            })
                          
                //        }
                //        else
                //        {
                //            newindex                = datasource.findIndex(x => x._id == items);
                //            if(newds[newindex].totalamount != undefined)
                //            {
                //                temptotalamount = temptotalamount + newds[newindex].totalamount
                //             }
                //         }
                //    }
                //    else
                //    {
                       newindex                = datasource.findIndex(x => x._id == items);
                       if(newds[newindex].totalamount != undefined)
                       {
                           temptotalamount = temptotalamount + newds[newindex].totalamount
                        }
                 //  }
                  
            
                })
        
            setdialogUpdateDetailCount(ActionCheckList.length)
            setdialogUpdateDetailAmount(temptotalamount.toLocaleString(undefined, {maximumFractionDigits:2}))
            setdialogUpdatedetailbutton(buttontext)
            setdialogUpdateDetailStatus(statuscode)
            setopenUpdatedialog(true)
        }
        else if(checkcode == 1)
        {
            var tempobj         = "unknown"
          
            let data = {
                id   :   ActionCheckList,
                status  :   statuscode
                }

            if(statuscode == 1)
            {
                tempobj = "approveddate"
                data["cbunread"] = 1
                data["veunread"] = 1
            }
            else if(statuscode == 2)
            {
                tempobj = "verifydate"
                data["cbunread"] = 1
                data["isunread"] = 1
            }
            else if(statuscode == 3)
            {
                let temppayid = Mpaymentacct.filter(x => x.label == Ipayid)[0].value
                tempobj = "issuedate"
                data["cbunread"] = 1
                data["cpunread"] = 1
                data["paymentacct"] = temppayid
                data["paydate"]  = moment(Ipaydate.$d).unix()
                data["itemscount"] = dialogUpdateDetailCount
                data["itemsamount"] = dialogUpdateDetailAmount
                data["itempayacct"] = Ipayid
                data["itemissueby"] = userid
            }
            else if(statuscode == 4)
            {
        
                // console.log('tempdata >>>',tempdata)

                // return 
                tempobj = "completeddate"
                data["cbunread"] = 1
                data["itemscount"] = dialogUpdateDetailCount
                data["itemsamount"] = dialogUpdateDetailAmount
            }
            else if(statuscode == 5)
            {
                tempobj = "exporteddate"
            }
            else if(statuscode == 8)
            {
                
                if(currentstatus == 3)
                {
                    data["payid"]    = ""
                    data["paydate"]  = 0
                    data["isunread"] = 1
                    data["status"]   = 2
                    data["currentstatus"]  = currentstatus
                }
                else
                {
                    
                    data["rejectby"] = userid
                    data["cbunread"] = 1
                }
                tempobj = "rejectdate"
            }
            else if(statuscode == 9)
            {
                tempobj = "canceldate"
            }

            data[tempobj] = moment().unix()
           

            console.log("data >>>>",data)
            var result = await onUpdatePayment(data)

            
            if(result.status == 'ok')
            {     
                LoadPaymentListing(CurrentFirstDay,CurrentLastDay)
                // ActionCheckList.forEach(function(items)
                // {
                
                //     let newindex                = datasource.findIndex(x => x._id == items);
                
                //     if(newds[newindex].status != undefined)
                //     {
                //         newds[newindex].status      = statuscode;
                //         newds[newindex].isChecked    = false;
                //     }
            
                // })
        
                // let tempstatuscode = currentstatus
                // if(currentstatus == -1 || currentstatus == -2)
                // {
                //     tempstatuscode = 0
                // }
                
                //let tempdata = newds.filter(x => x.status == tempstatuscode)
        
                let tempdata
                let filtertype

                if(currentstatus == -2)
                {
                    filtertype = "active"
                   
                }
                else if(currentstatus == -1)
                {
                    filtertype = "self"
                  
                }
                else 
                {
                    filtertype = "others"
                   
                }

                handleStatusClick(newds,currentstatus,filtertype)
                CalculateClaimAndPayment(newds)
                //setdatasourceByStatus([...tempdata])
                setopensnackupdate(true)
                
            }
            else
            {

                setopensnackerror(true)
            }
        
            setdialogUpdateDetailCount(0)
            setdialogUpdateDetailAmount(0)
            setdialogUpdatedetailbutton("")
            setdialogUpdateDetailStatus()
            setopenUpdatedialog(false)
            setActionCheckList([])
            //setIpayid("New Payment")
            setIpaydate()
            // console.log("datasource >>>",datasource)
            // console.log("datasourceByStatus >>>",datasourceByStatus)
            // console.log("result >>>",result)
            // console.log("currentstatus >>>",currentstatus)
            // console.log("ActionCheckList >>>",ActionCheckList)
        
        }
        else if(checkcode == 2)
        {
            let data = {
                id   :   tempid
                }

            if(tempdata.createdby == userid)
            {
                data["cbunread"] = 0 
            }
            
            if(tempdata.approvedby == userid)
            {
                data["apunread"] = 0
            }

            if(tempdata.verifyby == userid)
            {
                data["veunread"] = 0
            }

            if(tempdata.issueby == userid)
            {
                data["isunread"] = 0
            }

            if(tempdata.completedby == userid)
            {
                data["cpunread"] = 0
            }

            var result = onUpdatePayment(data)

            //LoadPaymentListing(CurrentFirstDay,CurrentLastDay)
        }
        else if(checkcode == 3)
        {
         
            let tempFULLdata                = datasource
            let tempdata1                   = datasourceByStatus
            let newFULLindex                = tempFULLdata.findIndex(x => x._id == tempid);
           
            
            let newindex                = tempdata1.findIndex(x => x.payid == tempdata.payid);
            let newindex2                = tempdata1[newindex].detailitems.findIndex(x => x._id == tempid);

            tempdata1[newindex].detailitems.splice(newindex2,1)

            var newtotalamount = 0

            if(tempdata1[newindex].detailitems.length > 0)
            {
                tempdata1[newindex].detailitems.forEach((items) => {

                    newtotalamount = newtotalamount + items.totalamount
                })
                tempdata1[newindex].totalamount = newtotalamount
            }
            else
            {
                tempdata1.splice(newindex,1)
            }
           

            if(tempFULLdata[newFULLindex].issueby != userid)
            {
                tempFULLdata.splice(newFULLindex,1)
            }
            else
            {
                tempFULLdata[newFULLindex].status = statuscode
                tempFULLdata[newFULLindex].payid = ""
                tempFULLdata[newFULLindex].isunread = 1
                tempFULLdata[newFULLindex].userunread = 1
            }

            let data = {
                id      :   [tempid],
                payid   :   "",
                isunread:   1,
                status  :   statuscode
                }

            var result = await onUpdatePayment(data)

           // LoadPaymentListing(CurrentFirstDay,CurrentLastDay)

           setdatasource(tempFULLdata)
           setdatasourceByStatus(tempdata1)
           CalculateClaimAndPayment(tempFULLdata)
           

        }
    
        setPogressStatus(false)
       }
    function dayjsdatechange(e)
    {
        if(e != null)
        {
            setdayjsdate(e)

        }
    }
    function Fmonthchange(e)
    {

      if(e != null)
      {
          setFmonth(e.value)

      }
    } 

    // function Ftypechange(e)
    // {

    //   if(e != null)
    //   {
    //       setFtype(e.value)

    //   }
    // } 

    function Fpaydatechange(e)
    {
      if(e.$d && e.$d != "Invalid Date")
      {
          setCinvdate(e)

      }
    }

    function Tpaydatechange(e)
    {
      if(e.$d && e.$d != "Invalid Date")
      {
          setTinvdate(e)
          
          if(ActionCheckList.length > 0)
            {
                setButtonTemplateDisable(false)
            }
            else
            {
                setButtonTemplateDisable(true)
            }

      }
      else
      {
        setButtonTemplateDisable(true)
      }
    }
    function Ipaydatechange(e)
    {
      if(e.$d && e.$d != "Invalid Date")
      {
          setIpaydate(e)
         
          if(ActionCheckList.length > 0)
            {
                setButtonDisable(false)
            }
            else
            {
                setButtonDisable(true)
            }

      }
      else
      {
        setButtonDisable(true)
      }
    }
    function Fsupplierchange(e,type,e2)
    {
      if(e != null)
      {

        console.log("e >>",e)
        if(type == 1)
        {
            
           // let tempdata = Mpayee.filter(x => x._id == e.value )[0];
            setCbank(e.bank)
            setCcurrency(e.currency)
            setCbankacct(e.bankacct)
            setCsupplierid(e.value)
            setCsupplier(e.payeeid)
            setCsupplierdesc(e.description)
            setSBankCurrencyDisable(true)
            setpreviewbankacctinput(true)

          
        }
        else if(type ==2)
        {
            setCbank("")
            setCcurrency("")
            setCbankacct("")
            setCsupplierid("")
            setCsupplier(e)
            setCsupplierdesc("")
            setSBankCurrencyDisable(false)
            setpreviewbankacctinput(false)
        }
        else if(type == 3)
        {
           
            let templisting = FULLtemplte
            let tempUpdatatemplate = templisting.map(x => x._id === e2._id ? ({...x, payee: e.payeeid} ) : (x))
            tempUpdatatemplate = tempUpdatatemplate.map(x => x._id === e2._id ? ({...x, payeedesc: e.description} ) : (x))
            tempUpdatatemplate = tempUpdatatemplate.map(x => x._id === e2._id ? ({...x, banktype: e.bank} ) : (x))
            tempUpdatatemplate = tempUpdatatemplate.map(x => x._id === e2._id ? ({...x, bankacct: e.bankacct} ) : (x))

            let tempUpdatatemplate2 = tempUpdatatemplate.filter(x => x._id === e2._id)[0]
           
            var result = onUpdateTemplate(tempUpdatatemplate2)

            setFULLtemplte(tempUpdatatemplate)
        }
          

      }
    }
    function Fbankchange(e,type)
    {
      if(e != null)
      {
          if(type == 1)
          {
            setCbank(e.value)
           
          }
          else
          {
              setCbank(e.toUpperCase())
              
          }
          

      }
    }
    function Fcurrencychange(e,type)
    {
      if(e != null)
      {
        if(type == 1)
        {
            setCcurrency(e.value)
        }
        else
        {
            setCcurrency(e.toUpperCase())
        }
          

      }
    }
    function Ftypechange(e,type,e2)
    {

      if(e != null)
      {
          if(type == 1)
          {
            setCtype(e.value)
            if(e.value == "CLAIM")
            {
                
                setCsupplier("")
                setCsupplierdesc("")
                setCbank("")
                setCbankacct("")
                setCcurrency("MYR")
            }
          }
          else if(type == 2)
          {
            let templisting = FULLtemplte
            let tempUpdatatemplate = templisting.map(x => x._id === e2._id ? ({...x, paytype: e.value} ) : (x))
            let tempUpdatatemplate2 = tempUpdatatemplate.filter(x => x._id === e2._id)[0]
           
            var result = onUpdateTemplate(tempUpdatatemplate2)
            setFULLtemplte(tempUpdatatemplate)
          }
          else
          {
            setCtype(e)
          }
          

      }
    }

    function Ipayidchange(e,type)
    {
      if(e != null)
      {
    
        if(type == 1)
        {
            setIpayid(e.label)
        }
        else
        {
            setIpayid(e)
        }
       

        //   if(e.value != "New Payment")
        //   {
        //     let tempdata = datasource.filter(x => x.status == 3  && x.payid == e.value)[0]

        //     var monthdateFormat = "YYYY/MM/DD"

        //     console.log("tempdata >>>",tempdata)
        //     setIpaydate(moment.unix(tempdata.paydate).format(monthdateFormat),monthdateFormat)
           
        
      }
    }
    function Ditemtypechange(e)
    {
      if(e != null)
      {
        setDitemtype(e.label)
        setDitemtypeID(e.value)
      }
    }

    function Fopendetailupload(e)
    {
        setDetailAttachHeader(e.Dsupplier + " - " + e.Damount)
        setCurrentCreateDetailID(e.Did)
        setCdetailfilelist(e.Dfilelist)
        setPreviewDetailFileList(true)
        setmodalVisiblePayCreate(false)
    }
    function Fopendetailupload2(e)
    {
        setDetailAttachHeader(e.Dsupplier + " - " + e.Damount)
        setPreviewDetailFileList2(true)
        setmodalVisibleDetailList(false)
    }
    function CalculateClaimAndPayment(xdata)
    {
        
        var statusarray = [0,1,2,3]

        // let tempCountActiveUnread = xdata.filter(x => x.createdby == userid && statusarray.includes(x.status) && x.userunread == true).length +
        //                             xdata.filter(x => x.approvedby == userid && x.status == 0 && x.userunread == true).length + 
        //                             xdata.filter(x => x.verifyby == userid && x.status == 1 && x.userunread == true).length +
        //                             xdata.filter(x => x.issueby == userid && x.status == 2 && x.userunread == true).length +
        //                             xdata.filter(x => x.completedby == userid && x.status == 3 && x.userunread == true).length
       
        // let Acountactive        = xdata.filter(x => statusarray.includes(x.status)).length
        
        // let Aunreadactive       = tempCountActiveUnread

        // let Bcountself          = xdata.filter(x => x.createdby == userid && x.status != 9).length
        // let Bunreadself         = xdata.filter(x => x.createdby == userid && x.userunread == true && x.status != 9).length

        let Ccountrejected      = xdata.filter(x => x.status == 8).length
        let Cunreadrejected     = xdata.filter(x => x.userunread == true && x.status == 8).length

        let Dcountwaitapproval  = xdata.filter(x => x.status == 0).length
        let Dunreadwaitapproval = xdata.filter(x => x.status == 0 && x.userunread == true).length

        let Ecountwaitverify    = xdata.filter(x => x.status == 1).length
        let Eunreadwaitverify   = xdata.filter(x => x.status == 1 && x.userunread == true).length

        let Fcountwaitissue     = xdata.filter(x => x.status == 2).length
        let Funreadwaitissude   = xdata.filter(x => x.status == 2 && x.userunread == true).length

        //let tempdata = xdata.filter(x => x.status == 3 && x.completedby == userid)
        let tempdata = xdata.filter(x => x.status == 3 )
        let tempdata1 = xdata

        if(tempdata.length > 0)
        {
            const groupedItems = tempdata.reduce((groups, item) => {
                const { paymentacct, issuebyname,totalamount, totalqty } = item;
                const key = `${paymentacct}`;
                if (!groups[key]) {
                  groups[key] = { _id: paymentacct,paymentacct,issuebyname,userunread : false,isOpen : false,isChecked : false,detailitems : tempdata.filter(x => x.paymentacct == paymentacct),
                                totalamount: totalamount, totalqty: totalqty,isInderterminate : false };
                } else {
                  groups[key].totalamount += totalamount;
                  groups[key].totalqty += totalqty;
                }
                return groups;
              }, {});

              tempdata = Object.values(groupedItems)

              tempdata1.forEach((items) => {

                if(items.userunread == 1)
                {
                    let newindex                  = tempdata.findIndex(x => x.paymentacct == items.paymentacct);
                   
                    if(newindex != -1)
                    {
                        tempdata[newindex].userunread = true
                    }
                  
                }
               
              })
        }
               

        let Gcountcompleted     = tempdata.length
        let Gunreadcompleted    = tempdata.filter(x => x.userunread == true).length

        let Hcountcancel        = xdata.filter(x => x.status == 9).length

        let tempdata2 = xdata.filter(x => x.status == 4 && x.exportedby == userid)
        let tempdata3 = xdata

        if(tempdata2.length > 0)
        {
            const groupedItems = tempdata2.reduce((groups, item) => {
                const { payid, paymentacct,totalamount, totalqty,completeddate } = item;
                const key = `${payid}`;
                if (!groups[key]) {
                  groups[key] = { _id: payid,payid,paymentacct,completeddate,userunread : false,isOpen : false,isChecked : false,detailitems : tempdata2.filter(x => x.payid == payid),
                                totalamount: totalamount, totalqty: totalqty,isInderterminate : false };
                } else {
                  groups[key].totalamount += totalamount;
                  groups[key].totalqty += totalqty;
                }
                return groups;
              }, {});

              tempdata2 = Object.values(groupedItems)

              tempdata3.forEach((items) => {

                if(items.userunread == 1)
                {
                    let newindex                  = tempdata.findIndex(x => x.payid == items.payid);
                   
                    if(newindex != -1)
                    {
                        tempdata[newindex].userunread = true
                    }
                  
                }
               
              })
        }
        let Icountexport     = tempdata2.length
        let Iunreadexport    = tempdata2.filter(x => x.userunread == true).length

        let Jcountdone      = xdata.filter(x => x.status == 4).length
        let Junreaddone     = xdata.filter(x => x.status == 4 && x.userunread == true).length

        // setCountActive(Acountactive)
        // setUnreadActive(Aunreadactive)

        // setCountSelf(Bcountself)
        // setUnreadSelf(Bunreadself)

        setCountRejected(Ccountrejected)
        setUnreadRejected(Cunreadrejected)

        setCountWaitApproval(Dcountwaitapproval)
        setUnreadWaitApproval(Dunreadwaitapproval)

        setCountWaitVerify(Ecountwaitverify)
        setUnreadWaitVerify(Eunreadwaitverify)

        setCountWaitIssue(Fcountwaitissue)
        setUnreadWaitIssue(Funreadwaitissude)

        setCountCompleted(Gcountcompleted)
        setUnreadCompleted(Gunreadcompleted)

        setCountCancel(Hcountcancel)

        setCountExport(Icountexport)
        setUnreadExport(Iunreadexport)

        setCountDone(Jcountdone)
        setUnreadDone(Junreaddone)

    }
    function RemoveDetailItemsList(e)
    {
        
        let tempdata = Cdetailitemslist.filter(x => x.Did != e );
        var newlist = [];
        var obj = {};
        var count = 0;
       
        tempdata.forEach((items) =>{
            obj={}
            obj["Did"]              = count
            obj["Ditemtype"]        = items.Ditemtype
            obj["Ddescription"]     = items.Ddescription
            obj["Dqty"]             = parseFloat(items.Dqty)
            obj["Dpriceunit"]       = parseFloat(items.Dpriceunit) 
            obj["Dtotalprice"]      = parseFloat(items.Dqty) * parseFloat(items.Dpriceunit) 
            obj["Dstatus"]          = 1
            count++
            newlist.push(obj)
        })
      
      
        setCdetailitemslist([...newlist])
        const totalqty = subtotalqty(newlist);
        const totalprice = subtotaldetailprice(newlist);
       
        if(CurrentDetailType == "create")
        {
            setDtotalqty(totalqty)
            setDtotalprice(totalprice)
            setCdetailitemsheader(newlist.length+" Items, "+totalprice.toLocaleString(undefined, {maximumFractionDigits:2}))
        }
        else
        {
            setDtotalqty(0)
            setDtotalprice(0)
            setCdetailitemsheader("Detail Items")
       
        }
    }
    function handleDetailListingOpen(e,val)
    {
        if(e == 1)
        {
           // setCdetailitemslist([])
           // setCurrentDetailType("create")
        }
        else if(e == 2)
        {
            setCurrentDetailType("template")
            setCurrentCreateDetailID(val._id)
            setCdetailitemslist(val.detailitems)
        }
       
        setmodalVisiblePayCreate(true)
    }
    function handleDetailListingClose(e)
    {
        if(CurrentDetailType == "create")
        {

        }
        else if(CurrentDetailType == "template")
        {
            let templisting = FULLtemplte
            let tempUpdatatemplate = templisting.map(x => x._id === CurrentCreateDetailID ? ({...x, detailitems: Cdetailitemslist} ) : (x))

            const totalqty = subtotalqty(Cdetailitemslist);
            const totalprice = subtotaldetailprice(Cdetailitemslist);

            tempUpdatatemplate = tempUpdatatemplate.map(x => x._id === CurrentCreateDetailID ? ({...x, totalqty: totalqty} ) : (x))
            tempUpdatatemplate = tempUpdatatemplate.map(x => x._id === CurrentCreateDetailID ? ({...x, totalamount: totalprice} ) : (x))

            let tempUpdatatemplate2 = tempUpdatatemplate.filter(x => x._id === CurrentCreateDetailID)[0]
           
            var result = onUpdateTemplate(tempUpdatatemplate2)

            setFULLtemplte(tempUpdatatemplate)

            // console.log("totalqty >>>>",totalqty)
            // console.log("tempUpdatatemplate >>>>",tempUpdatatemplate)
            // console.log("CurrentCreateDetailID >>>>",CurrentCreateDetailID)
            // console.log("Cdetailitemslist >>>>",Cdetailitemslist)
            setCdetailitemslist([])
            setCurrentCreateDetailID()
        }
        setmodalVisiblePayCreate(false)
    }

    function handleEditClick(items)
    {
        console.log("items >>>",items)
        setcurrentstatus(-3)
        setCurrentDetailType("edit")

        // invdate         : moment(Cinvdate.$d).unix(),
        // title           : Ctitle,
        // description     : Cdetail,
        // payee           : Csupplier,
        // banktype        : Cbank,
        // bankacct        : Cbankacct,
        // bankcurrency    : Ccurrency,
        // paytype         : Ctype,
        // detailitems     : Cdetailitemslist,
        // totalamount     : Dtotalprice,
        // totalqty        : Dtotalqty,
        // remarks         : Cremark,
        var monthdateFormat = "YYYY/MM/DD"

        setCurrentEditID(items._id)
        setCinvdate(dayjs(moment.unix(items.invdate).format(monthdateFormat),monthdateFormat))
        setCtitle(items.title)
        setCdetail(items.description)
        setCsupplier(items.payee)
        setCsupplierdesc(items.payeedesc ? items.payeedesc : '')
        setCbank(items.banktype)
        setCbankacct(items.bankacct)
        setCcurrency(items.bankcurrency)
        setCtype(items.paytype)
        setCdetailitemslist([...items.detailitems])
        setDtotalprice(items.totalamount)
        setDtotalqty(items.totalqty)
        setCremark(items.remarks)
        setCdetailitemsheader(items.detailitems.length+" Items, "+items.totalamount.toLocaleString(undefined, {maximumFractionDigits:2}))
    }
    function handleModalDetailListClose()
    {
       
        setmodalVisibleDetailList(false)
    }

    function handleDialogOpen()
    {
        setopendialog(false)
        setmodalVisibleDetailList(true)
    }
    function handleDialogClose()
    {
        setopendialog(false)
        setopenUpdatedialog(false)
    }
   
    function handleSnackClose()
    {
        setopensnacksuccess(false)
        setopensnackfail(false)
        setopensnackerror(false)
        setopensnackupdate(false)
    }
   
    const onCollapse = (val) => {
        //==== IF THE VAL INSIDE ARRAY MORE THAN 1 ====
        if(val.length > 1){
            val.splice(0, 1);
        }
        setCollapse(val); 
       
    }

    const handleListClick = (item, type) =>{
      
        let tempUpdataFulldatasource = datasource
        let tempUpdataStatusdatasource = datasourceByStatus
        //var tempUpdataFulldatasource,tempUpdataStatusdatasource

        if(type == 1)
        {
            if(item.userunread == true)
            {
                tempUpdataFulldatasource = tempUpdataFulldatasource.map(e => e.id === item._id ? ({...e, userunread: !e.userunread} ) : (e))
                tempUpdataStatusdatasource = tempUpdataStatusdatasource.map(e => e.id === item._id ? ({...e, userunread: !e.userunread} ) : (e))
    
                setdatasource(tempUpdataFulldatasource)
                CalculateClaimAndPayment(tempUpdataFulldatasource)
    
               UpdatePaymentStatus(currentstatus,"",2,[item.id],item)
            }
        }

        let tempdatasource = tempUpdataStatusdatasource
        let tempdatasource1 = tempUpdataStatusdatasource
        
        
        if(type == 1)
        {
            tempdatasource = tempUpdataStatusdatasource.map(e => e._id === item._id ? ({...e, isOpen: !e.isOpen} ) : (e))
            tempdatasource1 = tempdatasource.map(e => e._id !== item._id ? ({...e, isOpen: false} ) : (e))
        

            setdatasourceDetail(
                item.detailitems
            )
        }
        else if(type == 2)
        {
            tempdatasource = tempUpdataStatusdatasource.map(e => e._id === item._id ? ({...e, isOpen: !e.isOpen} ) : (e))
            tempdatasource1 = tempdatasource.map(e => e._id !== item._id ? ({...e, isOpen: false} ) : (e))

            
        }
        else if(type == 3)
        {
            let newindex
            if(currentstatus == 3)
            {
                 newindex                = tempUpdataStatusdatasource.findIndex(x => x.paymentacct == item.paymentacct);
           
            }
            else if (currentstatus == 4)
            {
                 newindex                = tempUpdataStatusdatasource.findIndex(x => x.payid == item.payid);
            }

           let newindex2                = tempUpdataStatusdatasource[newindex].detailitems.findIndex(x => x._id == item._id);
            
           
            tempUpdataStatusdatasource[newindex].detailitems[newindex2].isOpen = !tempUpdataStatusdatasource[newindex].detailitems[newindex2].isOpen

            var runindex = 0
     
            if(tempUpdataStatusdatasource[newindex].detailitems[newindex2].userunread == true)
            {
                tempUpdataStatusdatasource[newindex].detailitems[newindex2].userunread = false

                tempUpdataStatusdatasource[newindex].userunread = false

                tempUpdataFulldatasource = tempUpdataFulldatasource.map(e => e.id === item._id ? ({...e, userunread: false} ) : (e))
              
              
            }
            tempUpdataStatusdatasource[newindex].detailitems.forEach((items) =>{

                if(runindex != newindex2)
                {
                    tempUpdataStatusdatasource[newindex].detailitems[runindex].isOpen = false
                }
                if(items.userunread == true)
                {
                    tempUpdataStatusdatasource[newindex].userunread = true
                }
                runindex ++
            })
            tempdatasource1 = tempUpdataStatusdatasource

            setdatasource(tempUpdataFulldatasource)

            CalculateClaimAndPayment(tempUpdataFulldatasource)
 
            UpdatePaymentStatus(currentstatus,"",2,[item.id],item)
         
            setdatasourceDetail2(
                item.detailitems
            )
        }
        else if(type == 4)
        {
            

            let newindex, newindex2

            newindex                = tempUpdataStatusdatasource.findIndex(x => x.paymentacct == item.paymentacct);
            newindex2                = tempUpdataStatusdatasource[newindex].issueruserlists.findIndex(x => x.issuebyname == item.issuebyname);

            tempUpdataStatusdatasource[newindex].issueruserlists[newindex2].isOpen = !tempUpdataStatusdatasource[newindex].issueruserlists[newindex2].isOpen

            setdatasource(tempUpdataFulldatasource)
            tempdatasource1 = tempUpdataStatusdatasource



        }
       
        
        setdatasourceByStatus(
            [...tempdatasource1]
        )

       
      };

    function handleCheckListClick(item1,item2,item3,item4) {
        
        let tempchecklist = ActionCheckList
       
        let newds                   = datasourceByStatus;
        let newds3                  = datasource;

        console.log("item1 >>>>",item1)
        console.log("item2 >>>>",item2)
        console.log("item3 >>>>",item3)
        console.log("item4 >>>>",item4)
        if(currentstatus == 3)
        {
            if(item4 == "check all")
            {
                tempchecklist = []
                let tempindex               = newds.findIndex(x => x._id == item3.paymentacct)


                let tempUpdatate            = newds.map(x => x._id !== item3.paymentacct ? ({...x, isInderterminate: false, isChecked : false} ) : (x))

                var runnumber = 0
                tempUpdatate.forEach((item) => { 
                    if(runnumber != tempindex)
                    {
                       if(item.detailitems)
                       {
                           for(let x = 0;x < item.detailitems.length; x++)
                           {
                               tempUpdatate[runnumber].detailitems[x].isChecked = false
                           }
                       }
                    }
                    else if(runnumber == tempindex)
                    {
                        if(item3.isInderterminate == true)
                        {
                            for(let x = 0;x < item.detailitems.length; x++)
                            {
                                tempUpdatate[runnumber].detailitems[x].isChecked = false
                            }
                        }
                        else
                        {
                            if(item2.target.checked == true)
                            {
                                for(let x = 0;x < item.detailitems.length; x++)
                                {
                                    tempUpdatate[runnumber].detailitems[x].isChecked = true
                                    tempchecklist.push(tempUpdatate[runnumber].detailitems[x]._id)
                                }
                            }
                            else
                            {
                                for(let x = 0;x < item.detailitems.length; x++)
                                {
                                    tempUpdatate[runnumber].detailitems[x].isChecked = false
                                }
                            }
                            
                        }
                    }
                    runnumber++
                })
                if(item3.isInderterminate == true)
                {
                    tempUpdatate            = tempUpdatate.map(x => x._id === item3.paymentacct ? ({...x, isInderterminate: false, isChecked : false} ) : (x))
                }
                else
                {
                    tempUpdatate            = tempUpdatate.map(x => x._id === item3.paymentacct ? ({...x, isInderterminate: false, isChecked : !x.isChecked} ) : (x))
           
                }

                newds = tempUpdatate

            }
            else
            {
                if(item2.target.checked == true)
                {
                    tempchecklist.push(item1)
                }
                else
                {
                   tempchecklist = tempchecklist.filter(x => x !== item1)
                }

                let temppaymentacct         = newds3.filter(x => x._id == item1)[0].paymentacct
                let tempindex               = newds.findIndex(x => x._id == temppaymentacct)
                let tempchecklist2          = newds[tempindex].detailitems.filter(x => x == item1)
                let newindex                = newds[tempindex].detailitems.findIndex(x => x._id == item1);
                if(tempchecklist2)
                {
                    if(item2.target.checked == true)
                    {
                        newds[tempindex].detailitems[newindex].isChecked = true
                    }
                    else
                    {
                        newds[tempindex].detailitems[newindex].isChecked = false
                    }
                    
                    if(tempchecklist.length >> 0)
                    {
                        if(tempchecklist.length == newds[tempindex].detailitems.length)
                        {
                            newds[tempindex].isInderterminate = false
                            newds[tempindex].isChecked = true
                        }
                        else
                        {
                            newds[tempindex].isInderterminate = true
                            newds[tempindex].isChecked = false
                        }
                    }
                    else
                    {
                        newds[tempindex].isInderterminate = false
                        newds[tempindex].isChecked = false
                    }
                    
                }

            }
           
        }
        else
        {
           
        
            if(item2.target.checked == true)
            {
                tempchecklist.push(item1)
            }
            else
            {
               tempchecklist = tempchecklist.filter(x => x !== item1)
            }

            let tempchecklist2          = newds.filter(x => x == item1)
            let newindex                = newds.findIndex(x => x._id == item1);
            if(tempchecklist2)
            {
                if(item2.target.checked == true)
                {
                    newds[newindex].isChecked = true
                }
                else
                {
                    newds[newindex].isChecked = false
                }
                
            }
        }
       

        console.log("tempchecklist >>>",tempchecklist)
        setdatasourceByStatus([...newds])
        setActionCheckList(tempchecklist)

        if(tempchecklist.length > 0)
        {
            if(currentstatus == 2)
            {
                
                if(Ipaydate != null && Ipaydate != '' && Ipaydate != undefined)
                {
                    setButtonDisable(false)
                }
            }
            else
            {
                setButtonDisable(false)
            }
            
        }
        else
        {
            setButtonDisable(true)
        }

        if(tempchecklist.length == datasourceByStatus.length)
        {
            setCheckAllIndeterminate(false)
            setCheckAllchecked(true)
        }
        else
        {
            if(tempchecklist.length ==0 )
            {
                setCheckAllIndeterminate(false)
                setCheckAllchecked(false)
            }
            else
            {
                setCheckAllIndeterminate(true)
                setCheckAllchecked(false)
            }

        }
    }

    const CheckAllFunction = () =>
    {

        let tempdata = datasourceByStatus
        let tempchecklist = []
        var tempstatus = true
        if(CheckAllchecked == false)
        {
            tempstatus = true
            setCheckAllchecked(true)
            setCheckAllIndeterminate(false)
        }
        else
        {
            tempstatus = false
            setCheckAllchecked(false)
            setCheckAllIndeterminate(false)
        }
        for(let x = 0; x < tempdata.length;x++)
        {
            if(currentstatus == 0 && tempdata[x].checkapprove == true)
            {
                tempdata[x].isChecked = tempstatus
                if(CheckAllchecked == false)
                {
                    tempchecklist.push(tempdata[x]._id)
                }
            }
            else if(currentstatus == 1 && tempdata[x].checkverify == true)
            {
                tempdata[x].isChecked = tempstatus
                if(CheckAllchecked == false)
                {
                    tempchecklist.push(tempdata[x]._id)
                }
            }
            else if(currentstatus == 2 && tempdata[x].checkissue == true)
            {
                tempdata[x].isChecked = tempstatus
                if(CheckAllchecked == false)
                {
                    tempchecklist.push(tempdata[x]._id)
                }
            }
            else if(currentstatus == 8 || currentstatus == 9)
            {
                tempdata[x].isChecked = tempstatus
                if(CheckAllchecked == false)
                {
                    tempchecklist.push(tempdata[x]._id)
                }
            }
           
        }
        if(CheckAllchecked == true)
        {
            tempchecklist = []
          
            setButtonDisable(true)
        }
        else
        {
            if(currentstatus == 2)
            {
               
                if(Ipaydate != null && Ipaydate != '' && Ipaydate != undefined)
                {
                    setButtonDisable(false)
                }
            }
            else
            {
                if(tempchecklist.length > 0)
                {
                    setButtonDisable(false)
                }
                else
                {
                    setButtonDisable(true)
                }
            }
        }
        

        console.log("tempchecklist >>>>",tempchecklist)
        setActionCheckList(tempchecklist)
        setdatasourceByStatus([...tempdata])

    }
    async function handleModalHistoryOpen(itemdata)
    {
       // setPogressStatus(true)
        setmodalVisibleHistory(true)
       // var result = await onLoadPaymentByPayee({payee : itemdata.payee, payeedesc : itemdata.payeedesc, bankacct : itemdata.bankacct })
       

        // if(result.data.length > 0)
        // {
         //    setmodalHistoryHeader("Histroy Last 5 Transactions (" + result.data[0].payee + " - " + result.data[0].payeedesc +")")
        // }
        setmodalHistoryHeader("Histroy Transactions (" + itemdata.payee + " - " + itemdata.payeedesc +")")
        setCurrentTotalAmount(itemdata.totalamount)
        setdatasourceHistrory(itemdata.history)
       // setPogressStatus(false)
    }
    async function handleModalHistoryClose()
    {
        setdatasourceHistrory([])
        setmodalHistoryHeader("")
        setCurrentTotalAmount(0)
        setmodalVisibleHistory(false)
    }
    const handleStatusClick = (fulldata,statuscode,filtertype) => {

        let tempdata = fulldata
        var statusarray = [0,1,2,3]
     
        setCheckAlldisable(true)

        tempdata.forEach(items => {
            items.isChecked = false;
            items.isOpen = false;
          });

          setdatasource(tempdata)
          
        if(filtertype == 'active')
        {
            
            tempdata = tempdata.filter(x => statusarray.includes(x.status))
        }
        else if(filtertype == 'self')
        {
            tempdata = tempdata.filter(x => x.createdby == userid && x.status != 9)
        }
        else if(filtertype == 'others')
        {
            if(statuscode == 0)
            {
                tempdata = tempdata.filter(x => x.status == statuscode)

                tempdata.forEach((items) => {
                    if(items.checkapprove == true)
                    {
                        setCheckAlldisable(false)

                    }
                })

                tempdata = tempdata.sort((a,b)=> (b.checkapprove.toString().localeCompare(a.checkapprove.toString()) ||
                b.userunread.toString().localeCompare(a.userunread.toString()) ||
                b.createddate.toString().localeCompare(a.createddate.toString()) ))
                
            }
            else if(statuscode == 1)
            {
                tempdata = tempdata.filter(x => x.status == statuscode)
                tempdata.forEach((items) => {
                    if(items.checkverify == true)
                    {
                        setCheckAlldisable(false)
                        
                    }
                })
                tempdata = tempdata.sort((a,b)=> (b.checkverify.toString().localeCompare(a.checkverify.toString()) ||
                b.userunread.toString().localeCompare(a.userunread.toString()) ||
                b.createddate.toString().localeCompare(a.createddate.toString()) ))
            }
            else if(statuscode == 2)
            {
                tempdata = tempdata.filter(x => x.status == statuscode)
                tempdata.forEach((items) => {
                    if(items.checkissue == true)
                    {
                        setCheckAlldisable(false)
                        
                    }
                })
                tempdata = tempdata.sort((a,b)=> (b.checkissue.toString().localeCompare(a.checkissue.toString()) ||
                b.userunread.toString().localeCompare(a.userunread.toString()) ||
                b.createddate.toString().localeCompare(a.createddate.toString()) ))
            }
            else if(statuscode == 3)
            {
               
                if(usercompletelist.includes(userid))
                {
                  
                    //tempdata = tempdata.filter(x => x.status == statuscode && x.completedby == userid)
                    tempdata = tempdata.filter(x => x.status == statuscode)
                   
                    let tempdata3 = tempdata
                    const groupedItems1 = tempdata.reduce((groups, item) => {
                        const { paymentacct, issuebyname,totalamount, totalqty } = item;
                        const key = `${paymentacct, issuebyname}`;
                        if (!groups[key]) {
                          groups[key] = { _id: paymentacct,paymentacct,issuebyname : issuebyname,userunread : false,isOpen : false,isChecked : false,
                                        detailitems : tempdata.filter(x => x.paymentacct == paymentacct && x.issuebyname == issuebyname),
                                        totalamount: totalamount, totalqty: totalqty, isInderterminate : false , isWarning : false};
                        } else {
                          groups[key].totalamount += totalamount;
                          groups[key].totalqty += totalqty;
                        }
                        return groups;
                      }, {});
    
                      tempdata3 = Object.values(groupedItems1)


                    let tempdata1 = tempdata
                    const groupedItems = tempdata.reduce((groups, item) => {
                        const { paymentacct, issuebyname,totalamount, totalqty } = item;
                        const key = `${paymentacct}`;
                        if (!groups[key]) {
                          groups[key] = { _id: paymentacct,paymentacct,issuebyname,userunread : false,isOpen : false,isChecked : false,
                                        issueruserlists : tempdata3,
                                        detailitems : tempdata.filter(x => x.paymentacct == paymentacct),
                                        totalamount: totalamount, totalqty: totalqty, isInderterminate : false , isWarning : false};
                        } else {
                          groups[key].totalamount += totalamount;
                          groups[key].totalqty += totalqty;
                        }
                        return groups;
                      }, {});
    
                      tempdata = Object.values(groupedItems)
    
                      const leftJoin = Mpaymentacct.map(leftObj => {
                        const rightObj = tempdata.find(rightObj => rightObj._id === leftObj.payid);
                        return {...leftObj, ...rightObj};
                      });
    
                      console.log("leftJoin >>>>",leftJoin)
                      tempdata = leftJoin
    
                      tempdata1.forEach((items) => {
    
                        if(items.userunread == 1)
                        {
                            let newindex                  = tempdata.findIndex(x => x.paymentacct == items.paymentacct);
                          
                            if(newindex != -1)
                            {
                                tempdata[newindex].userunread = true
                            }
                        }
                       
                      })
                }
                else
                {
                    tempdata = tempdata.filter(x => x.status == statuscode)
                    tempdata.forEach((items) => {
                    if(items.checkissue == true)
                    {
                        setCheckAlldisable(false)
                        
                    }
                    })
                    tempdata = tempdata.sort((a,b)=> (b.checkcomplete.toString().localeCompare(a.checkcomplete.toString()) ||
                    b.userunread.toString().localeCompare(a.userunread.toString()) ||
                    b.createddate.toString().localeCompare(a.createddate.toString()) ))
                }
                
                
            }
            else if(statuscode == 4)
            {
                
                tempdata = tempdata.filter(x => x.status == statuscode)
                let tempdata1 = tempdata
                const groupedItems = tempdata.reduce((groups, item) => {
                    const { payid, paymentacct,totalamount, totalqty,completeddate } = item;
                    const key = `${payid}`;
                    if (!groups[key]) {
                      groups[key] = { _id: payid,payid,paymentacct,completeddate,userunread : false,isOpen : false,isChecked : false,detailitems : tempdata.filter(x => x.payid == payid),
                                    totalamount: totalamount, totalqty: totalqty , isInderterminate : false};
                    } else {
                      groups[key].totalamount += totalamount;
                      groups[key].totalqty += totalqty;
                    }
                    return groups;
                  }, {});

                  tempdata = Object.values(groupedItems)

                  tempdata1.forEach((items) => {

                    if(items.exporteddate == 0)
                    {
                        let newindex                  = tempdata.findIndex(x => x.paymentacct == items.paymentacct);
                      
                        if(newindex != -1)
                        {
                            tempdata[newindex].userunread = true
                        }
                     
                    }
                   
                  })
            }
            else if(statuscode == 5)
            {
                tempdata = tempdata.filter(x => x.status == 4)
                tempdata = tempdata.sort((a,b)=> (b.userunread.toString().localeCompare(a.userunread.toString()) ||
                    b.createddate.toString().localeCompare(a.createddate.toString()) ))
            
                
            }
            else if(statuscode == 8)
            {
                tempdata = tempdata.filter(x => x.status == statuscode)
                tempdata.forEach((items) => {
                    if(items.checkcancel == true)
                    {
                        setCheckAlldisable(false)
                        
                    }
                })
                tempdata = tempdata.sort((a,b)=> (b.checkcancel.toString().localeCompare(a.checkcancel.toString()) ||
                b.userunread.toString().localeCompare(a.userunread.toString()) ||
                b.createddate.toString().localeCompare(a.createddate.toString()) ))
            }
            else
            {
                tempdata = tempdata.filter(x => x.status == statuscode)
            }
            
        }
        else if(filtertype == 'create')
        {

        }
        
        console.log("status data >>>",tempdata)
        setCurrentDetailType("create")
        setcurrentstatus(statuscode)
        setcurrentfilter(filtertype)
        setdatasourceByStatus(tempdata)
        setActionCheckList([])
        setCheckAllIndeterminate(false)
        setCheckAllchecked(false)
        setButtonDisable(true)
    }

    async function LoadPaymentListing(firstDay,lastDay) {

        var result = await onLoadPayment({firstDay:firstDay,lastDay:lastDay,userid:userid})
        var userresult = await  LoadFullUserListing()
        //var resultpayee = await onLoadPayeeActive("")
        var temppayeelist = []
        var newlist = []
        var obj     = {}

        
        // resultpayee.data.forEach((items) =>{
        //     obj = {}

        //     obj["label"]            = items.description ? items.payeeid + " - " + items.description : items.payeeid
        //     obj["value"]            = items.payeeid
        //     obj["bank"]             = items.bank
        //     obj["bankacct"]         = items.bankacct
        //     obj["currency"]         = items.currency
        //     obj["payeeid"]          = items.payeeid
        //     obj["type"]             = items.type
        //     obj["description"]      = items.description ? items.description : ""
        //     obj["lastpayamount"]    = items.lastpayamount ? items.lastpayamount : 0
        //     obj["lastpaydate"]      = items.lastpaydate ? items.lastpaydate : 0


        //     newlist.push(obj)
        //     temppayeelist.push(obj)
        // })

        //setMpayee(newlist)

        newlist = []
        obj = {}
        result.data.forEach(function(items)
        {
            obj = {}

            let tempname1 = userresult.filter(x => x._id == items.createdby)[0] ? userresult.filter(x => x._id == items.createdby)[0] : ""
            let tempname2 = userresult.filter(x => x._id == items.approvedby)[0] ? userresult.filter(x => x._id == items.approvedby)[0] : ""
            let tempname3 = userresult.filter(x => x._id == items.verifyby)[0] ? userresult.filter(x => x._id == items.verifyby)[0] : ""
            let tempname4 = userresult.filter(x => x._id == items.issueby)[0] ? userresult.filter(x => x._id == items.issueby)[0] : ""
            let tempname5 = userresult.filter(x => x._id == items.completedby)[0] ? userresult.filter(x => x._id == items.completedby)[0] : ""
            let tempname6 = userresult.filter(x => x._id == items.exportedby)[0] ? userresult.filter(x => x._id == items.exportedby)[0] : ""
            let tempname7 = userresult.filter(x => x._id == items.rejectby)[0] ? userresult.filter(x => x._id == items.rejectby)[0] : ""
            // let temppayeedata = temppayeelist.filter(x => x.bankacct == items.bankacct && x.payeeid == items.payee && x.description == items.payeedesc) 
            // var lastamount = 0
            // var lastpaydate = 0
            // var isWarning = false
            
            // if(temppayeedata.length > 0)
            // {
               
            //     lastamount = temppayeedata[0].lastpayamount ? temppayeedata[0].lastpayamount : 0 
            //     lastpaydate = temppayeedata[0].lastpaydate ? temppayeedata[0].lastpaydate : 0
            // }
           
            // if( moment.unix(lastpaydate).format("M") ==  moment.unix(items.createddate).format("M") && 
            // moment.unix(lastpaydate).format("YYYY") == moment.unix(items.createddate).format("YYYY") && 
            // lastamount == items.totalamount)
            // {
            //     isWarning = true
            // }
            // obj["lastamount"]       =   lastamount
            // obj["lastpaydate"]      =   lastpaydate
            obj["id"]               =   items._id
            obj["_id"]              =   items._id
            obj["payid"]            =   items.payid   
            obj["paymentacct"]      =   items.paymentacct  
            obj["invdate"]          =   items.invdate
            obj["title"]            =   items.title
            obj["description"]      =   items.description
            obj["payee"]            =   items.payee
            obj["payeedesc"]        =   items.payeedesc
            obj["banktype"]         =   items.banktype
            obj["bankacct"]         =   items.bankacct
            obj["bankcurrency"]     =   items.bankcurrency
            obj["paytype"]          =   items.paytype
            obj["detailitems"]      =   items.detailitems
            obj["totalamount"]      =   items.totalamount
            obj["totalqty"]         =   items.totalqty
            obj["remarks"]          =   items.remarks
            obj["attachments"]      =   items.attachments
            obj["status"]           =   items.status
            obj["exported"]         =   items.exported
            obj["paydate"]          =   items.paydate
            obj["createdby"]        =   items.createdby
            obj["createdbyname"]    =   tempname1.userid +"("+tempname1.markingcode +")"
            obj["createddate"]      =   items.createddate
            obj["approvedby"]       =   items.approvedby
            obj["approvedbyname"]   =   tempname2.userid +"("+tempname2.markingcode +")"
            obj["approveddate"]     =   items.approveddate
            obj["verifyby"]         =   items.verifyby
            obj["verifybyname"]     =   tempname3.userid +"("+tempname3.markingcode +")"
            obj["verifydate"]       =   items.verifydate
            obj["issueby"]          =   items.issueby
            obj["issuebyname"]      =   tempname4.userid +"("+tempname4.markingcode +")"
            obj["issuedate"]        =   items.issuedate
            obj["completedby"]      =   items.completedby
            obj["completedbyname"]  =   tempname5.userid +"("+tempname5.markingcode +")"
            obj["completeddate"]    =   items.completeddate            
            obj["exportedby"]       =   items.exportedby
            obj["exportedbyname"]   =   tempname6.userid +"("+tempname6.markingcode +")"
            obj["exporteddate"]     =   items.exporteddate
            obj["rejectby"]         =   items.rejectby
            obj["rejectbyname"]     =   tempname7.userid +"("+tempname6.markingcode +")"
            obj["rejectdate"]       =   items.rejectdate
            obj["canceldate"]       =   items.canceldate
            obj["cbunread"]         =   items.cbunread
            obj["apunread"]         =   items.apunread
            obj["veunread"]         =   items.veunread
            obj["isunread"]         =   items.isunread
            obj["cpunread"]         =   items.cpunread
            obj["newpayee"]         =   items.newpayee
            obj["filepath"]         =   items.filepath
            obj["isOpen"]           =   false
            obj["isChecked"]        =   false
            obj["isWarning"]        =   items.isWarning
            obj["updatedte"]        =   items.updatedte
            obj["history"]          =   items.history
            var userunread          =   false
            var checkapprove        =   false
            var checkverify         =   false
            var checkissue          =   false
            var checkcomplete       =   false
            var checkcancel         =   false
            if(items.createdby == userid)
            {
                if(items.cbunread == 1)
                {
                    userunread = true
                }
                checkcancel  = true
            }
            
                if(items.approvedby == userid)
                {
                    if(items.apunread == 1)
                    {
                        userunread = true
                    }

                    checkapprove = true
                   
                }
                if(items.verifyby == userid)
                {
                    if(items.veunread == 1)
                    {
                        userunread = true
                    }
                    checkverify = true
                }
                if(items.issueby == userid)
                {
                    if(items.isunread == 1)
                    {
                        userunread = true
                    }
                    checkissue = true
                }
                if(items.completedby == userid)
                {
                    if(items.cpunread == 1)
                    {
                        userunread = true
                    }
                    checkcomplete = true
                }
            
           
            obj["userunread"]       =   userunread
            obj["checkapprove"]     =   checkapprove
            obj["checkverify"]      =   checkverify
            obj["checkissue"]       =   checkissue
            obj["checkcomplete"]    =   checkcomplete
            obj["checkcancel"]      =   checkcancel
            newlist.push(obj)
        })

        // const newlist1 = newlist.sort((a, b) => {
        //     if (a.userunread > b.userunread) {
        //         return -1;
        //     }
        //     if (a.userunread < b.userunread) {
        //         return 1;
        //     }
        //     if (a.createddate.toString() < b.createddate.toString()) {
        //         return -1;
        //     }
        //     if (a.createddate.toString() > b.createddate.toString()) {
        //         return 1;
        //     }
           
        //     return 0;
        //   });

        var newlist1 = newlist.sort((a,b)=> (b.userunread.toString().localeCompare(a.userunread.toString()) 
        || b.createddate.toString().localeCompare(a.createddate.toString()) ))
        

        setdatasource(newlist1)

        // let tempdata = newlist.filter(x => x.status == 3 && x.completedby == userid)
        // let temppayid = [{value : "New Payment", label : "New Payment"}]
        // if(tempdata.length > 0)
        // {
        //     const groupedItems = tempdata.reduce((groups, item) => {
        //         const { payid, issuebyname,totalamount, totalqty } = item;
        //         const key = `${payid}`;
        //         if (!groups[key]) {
        //           groups[key] = { value: payid, label : payid};
        //         } else {
                 
        //         }
        //         return groups;
        //       }, {});

        //       let templist = Object.values(groupedItems)
        //       var newobj = {}
        //       templist.forEach((items) => {
                  
        //         newobj = {}
        //         newobj["value"] = items.value
        //         newobj["label"] = items.label

        //         temppayid.push(newobj)
        //       })
             

        // }

        // setpayidselect(temppayid)
        CalculateClaimAndPayment(newlist1)
        // var statusarray = [0,1,2,3]
        // let tempdata = newlist.filter(x => statusarray.includes(x.status))

        handleStatusClick(newlist1,currentstatus,currentfilter)

        // setdatasourceByStatus(tempdata)
        console.log("payment result >>>>",result.data)
        console.log("payment result2 >>>>",newlist1)
    }
    async function LoadPaymentAccountListing()
    {
        var result = await onLoadPaymentAcct("")

        var newlist = []
        var obj     = {}

        result.data.forEach((items) =>{
            obj = {}

            obj["label"]    = items.paydesc
            obj["value"]    = items.payid
            obj["currency"] = items.currency
            obj["payid"] = items.payid
            obj["paydesc"] = items.paydesc

            newlist.push(obj)
        })

        console.log("newlsit >>>>",newlist)
        setIpayid(newlist[0].label)
        setMpaymentacct(newlist)
        
    }
    async function LoadPayeeListing()
    {
        var result = await onLoadPayeeActive("")

        var newlist = []
        var obj     = {}

        
        result.data.forEach((items) =>{
            obj = {}

            obj["label"]            = items.description ? items.payeeid + " - " + items.description : items.payeeid
            obj["value"]            = items._id
            obj["bank"]             = items.bank
            obj["bankacct"]         = items.bankacct
            obj["currency"]         = items.currency
            obj["payeeid"]          = items.payeeid
            obj["type"]             = items.type
            obj["description"]      = items.description ? items.description : ""
            obj["lastpayamount"]    = items.lastpayamount ? items.lastpayamount : 0
            obj["lastpaydate"]      = items.lastpaydate ? items.lastpaydate : 0


            newlist.push(obj)
        })

        setMpayee(newlist)
        
    }
    async function LoadPaytypeListing()
    {
        var result = await onLoadPaytype("")

        var newlist = []
        var obj     = {}

        
        result.data.forEach((items) =>{
            obj = {}

            obj["label"]    = items.title 
            obj["value"]    = items.title
            obj["title"]     = items.title

            newlist.push(obj)
        })

        setMpaytype(newlist)
        
    }
    async function LoadFullUserListing()
    {
        var result = await getAllUserLists("")

        setFULLUserLists(result.data)

        return(result.data)
        
    }
    async function LoadAccountItemsListing()
    {
        var result = await onLoadAccoutItems("")

        var newlist = []
        var obj     = {}

        
        result.data.forEach((items) =>{
            obj = {}

            obj["label"]        = items.actitemdesc 
            obj["value"]        = items.actitemid
            obj["actitemid"]    = items.actitemid
            obj["actitemdesc"]  = items.actitemdesc
            obj["acttype"]      = items.acttype
           

            newlist.push(obj)
        })

        setMaacountitems(newlist)
        
    }
    async function LoadFullTemplate()
    {
        var result = await onLoadTemplate({userid : userid})
        var newlist = []
        var obj = {}
        result.data.forEach(function(items)
        {
            obj = {}

            
            obj["key"]              =   items._id
            obj["_id"]              =   items._id
            obj["invdate"]          =   items.invdate
            obj["title"]            =   items.title
            obj["description"]      =   items.description
            obj["payee"]            =   items.payee
            obj["payeedesc"]        =   items.payeedesc
            obj["banktype"]         =   items.banktype
            obj["bankacct"]         =   items.bankacct
            obj["bankcurrency"]     =   items.bankcurrency
            obj["paytype"]          =   items.paytype
            obj["detailitems"]      =   items.detailitems
            obj["totalamount"]      =   items.totalamount
            obj["totalqty"]         =   items.totalqty
            obj["remarks"]          =   items.remarks
            obj["createdby"]        =   items.createdby
            obj["createddate"]      =   items.createddate
            obj["filelist"]         =   []
            
            newlist.push(obj)
        })
       
        setFULLtemplte(newlist)
    }

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {

            const updatedRows = []

            for(var x = 0; x < selectedRows.length; x++)
            {
                updatedRows.push(selectedRows[x]._id)
            }

            setActionCheckList(updatedRows)
            if(selectedRows.length > 0)
            {
                if(Tinvdate.$d && Tinvdate.$d != "Invalid Date")
                {
                    setButtonTemplateDisable(false)
                }
                else
                {
                    setButtonTemplateDisable(true)
                }
            }
            else
            {
                setButtonTemplateDisable(true)
            }
          console.log('selectedRows: ', updatedRows);
        },
        getCheckboxProps: (record) => ({
          disabled: record.name === 'Disabled User',
          // Column configuration not to be checked
          name: record.name,
        }),
      };

      
      const EditableCell = ({
        title,
        editable,
        children,
        dataIndex,
        record,
        handleSave,
        ...restProps
      }) => {
        const [editing, setEditing] = useState(false);
        const inputRef = useRef(null);
        const form = useContext(EditableContext);
        useEffect(() => {
          if (editing) {
            inputRef.current.focus();
          }
        }, [editing]);
        const toggleEdit = () => {
          setEditing(!editing);
          form.setFieldsValue({
            [dataIndex]: record[dataIndex],
          });
        };
        const save = async () => {
          try {
        
            const values = await form.validateFields();
            toggleEdit();
            handleSave({
              ...record,
              ...values,
            });
          } catch (errInfo) {
            console.log('Save failed:', errInfo);
          }
        };
        let childNode = children;
        if (editable) {
          childNode = editing ? (
            <Form.Item
              style={{
                margin: 0,
              }}
              name={dataIndex}
              rules={[
                {
                  required: true,
                  message: `Require to fill in`,
                },
              ]}
            >
              <Input ref={inputRef} onPressEnter={save} onBlur={save} />
            </Form.Item>
          ) : (
            <div
              className="editable-cell-value-wrap"
              style={{
                paddingRight: 24,
              }}
              onClick={toggleEdit}
            >
              {children}
            </div>
          );
        }
        return <td {...restProps}>{childNode}</td>;
      };
      
      const handleSave = (row) => {
        const newData = [...FULLtemplte];
        const index = newData.findIndex((item) => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        }); 
        // console.log("newData >>>",newData)
        // console.log("newData[index] >>>",newData[index])
         var result = onUpdateTemplate(newData[index])
        setFULLtemplte(newData);
      };

      const handleDelete = (key) => {
        const newData = FULLtemplte.filter((item) => item.key !== key);
        
        let templisting = FULLtemplte
        let tempUpdatatemplate = templisting.map(x => x._id === key ? ({...x, active: 0} ) : (x))
        let tempUpdatatemplate2 = tempUpdatatemplate.filter(x => x._id === key)[0]
       

        var result = onUpdateTemplate(tempUpdatatemplate2)
        setFULLtemplte(newData);
      };
      const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
      };
    var defaultColumns = 
    [
        {
            title: <div>Title</div>,
            dataIndex: 'title',
            fixed: 'left',
            width: '15%',
            editable : true
        },  

        {
            title: <div>Payee</div>,
            dataIndex: '',
            key: '',
            width: '25%',
            render: text => 
            //<small >{text}</small>,
                <Autocomplete
                value={text.payee}
                onChange={(val1,val2) => Fsupplierchange(val2,3,text)}
                //onInputChange={(val1,val2) => Fsupplierchange(val2,2)}
                //nputValue={text.payee}
                options={Mpayee}
                isOptionEqualToValue={(option, value) => option.payeeid === value}
                renderInput={(params) => <TextField {...params} label="Payee" />}>

                </Autocomplete>
        },  

        {
            title: <div>Payee Description</div>,
            dataIndex: '',
            key: '',
            width: '10%',
            render: text => 
            <>
            <div>
                <small>{text.payeedesc}</small>
            </div>
            </>
        },  
        {
            title: <div>Bank</div>,
            dataIndex: '',
            key: '',
            width: '10%',
            render: text => 
            <>
            <div>
                <small>{text.banktype}</small>
                <br/>
                <small>{text.bankacct}</small>
            </div>
            </>
        },  


        {
            title: <div>Type</div>,
            dataIndex: '',
            key: '',
            width: '15%',
            render: text => 
                <Autocomplete 
               
                value={text.paytype}
                onChange={(val1,val2) => Ftypechange(val2,2,text)}
                options={paymenttypeselect}
                isOptionEqualToValue={(option, value) => option.value === value}
                renderInput={(params) => <TextField {...params} label="Payment Type" />}>
                </Autocomplete>
        },  

        {
            title: <div>Description</div>,
            dataIndex: 'description',
            key: '',
            width: '10%',
            editable : true
        },  

        {
            title: <div>Remark</div>,
            dataIndex: 'remarks',
            key: '',
            width: '10%',
            editable : true
        },  

        {
            title: <div>Items</div>,
            dataIndex: '',
            key: '',
            width: '10%',
            render: text => 
           
                <a onClick={(val1) => handleDetailListingOpen(2,text)}>
                    Items : {text.totalqty}, Amount : {text.totalamount.toLocaleString(undefined, {maximumFractionDigits:2})}
                </a>
         
            
        },
        {
          title: '',
          dataIndex: 'operation',
          width: '5%',
          render: (_, record) =>
            FULLtemplte.length >= 1 ? (
                <>
                <IconButton>
                <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}>
                <DeleteForeverIcon style={{color:"red"}}></DeleteForeverIcon>
              </Popconfirm>
                </IconButton>
                
              {/* <Upload {...PaymentAttProps}>

              <IconButton>
              <UploadOutlined style={{color:'blue'}}>
              </UploadOutlined>
              </IconButton>
                  </Upload>
               */}
             
              
                </>
              
            ) : null,
        },
        
     
    ]

    const templatecolumns = defaultColumns.map((col) => {
        if (!col.editable) {
          return col;
        }
        return {
          ...col,
          onCell: (record) => ({
            record,
            editable: col.editable,
            dataIndex: col.dataIndex,
            title: col.title,
            handleSave,
          }),
        };
      });
    useEffect(() => {
        
        var firstDay
        var lastDay
        let monthint = 0
        switch(Fmonth){
            case "JAN":
                monthint = 1;
                break;
            case "FEB":
                monthint = 2;
                break;
            case "MAR":
                monthint = 3;
                break;
            case "APR":
                monthint = 4;
                break;
            case "MAY":
                monthint = 5;
                break;
            case "JUN":
                monthint = 6;
                break;
            case "JUL":
                monthint = 7;
                break;
            case "AUG":
                monthint = 8;
                break;
            case "SEP":
                monthint = 9;
                break;
            case "OCT":
                monthint = 10;
                break;
            case "NOV":
                monthint = 11;
                break;
            case "DEC":
                monthint = 12; 
                break;       
        }
        var date = new Date(), y = yearvalue.$y, m = monthint;
        if(Fmonth == "ALL")
        {
            firstDay = new Date(y, 0, 1);
            lastDay = new Date(y, 12, 0);
        }
        else
        {
           
            firstDay = new Date(y, m-1, 1);
            lastDay = new Date(y, m, 0);
        }

        setCurrentFirstDay(dayjs(firstDay).unix())
        setCurrentLastDay(dayjs(lastDay).unix())
        LoadPaymentListing(dayjs(firstDay).unix(),dayjs(lastDay).unix())
       
    }, [yearvalue,Fmonth,Ftype]);

    useEffect(() => {
      
        LoadPaymentAccountListing()
        LoadPayeeListing()
        LoadPaytypeListing()
        LoadAccountItemsListing()
        LoadFullTemplate()
        setPogressStatus(false)

    },[])
    useEffect(() => {
      
    },[ActionCheckList,datasourceByStatus])
      return (
          <>
        <Row justify="start">
            <Divider>{GetTranslation(userlang,prop.title) ?? "." }</Divider>
        </Row>
       
        <Row>
        <Col style={{width:"45%"}}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Stack spacing={3}>
                    <DatePicker
                    views={['year']}
                    label="Year"
                    minDate={dayjs('2022-12-01')}
                    maxDate={dayjs('2028-12-01')}
                    value={yearvalue}
                    
                    onChange={(newValue) => {
                        setyearvalue(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} helperText={null} />}
                    />
                </Stack>
            </LocalizationProvider>
            </Col>
     
        <Col style={{width:"45%"}}>
            <Autocomplete
            value={Fmonth}
            onChange={(val1,val2) => Fmonthchange(val2)}
            options={monthselect}
            isOptionEqualToValue={(option, value) => option.value === value}
            sx={{ width: 195 }}
           
            renderInput={(params) => <TextField {...params} label="Month" />}
            />
            </Col>
            </Row>
            <Row >
            <div  style={{ display:"flex",alignItems:"center",overflow:"auto",whiteSpace:"nowrap", width:"100%",height:"100px"}}>
            <IconButton  onClick={(val) => handleStatusClick(datasource,-3,"create")}>
                <Badge  color="success" style={{paddingLeft:"10px"}}  >
                    <Item style={{fontSize:"11px",width:"150px",height:"50px", backgroundColor: currentstatus == -3 ? "lightgray" : "white"}}>  
                        <span style={{ fontWeight: 'bold' }}>{CurrentDetailType == "edit" ? "Edit payment" : "Create Payment"}</span>
                        <br/>
                        <a></a>
                    </Item>
                </Badge>
            </IconButton>
            {/* <IconButton  onClick={(val) => handleStatusClick(datasource,-2,"active")}>
                <Badge  badgeContent={UnreadActive} color="success" style={{paddingLeft:"10px"}}  >
                    <Item style={{fontSize:"11px",width:"150px",height:"50px", backgroundColor: currentstatus == -2 ? "lightgray" : "white"}}>  
                        <span style={{ fontWeight: 'bold' }}>Active</span>
                        <br/>
                        <a>{CountActive}</a>
                    </Item>
                </Badge>
            </IconButton>
            <IconButton onClick={(val) => handleStatusClick(datasource,-1,"self")}>
                <Badge  badgeContent={UnreadSelf} color="success" style={{paddingLeft:"10px"}}  >
                    <Item style={{fontSize:"11px",width:"150px",height:"50px", backgroundColor: currentstatus == -1 ? "lightgray" : "white"}}>  
                        <span style={{ fontWeight: 'bold' }}>Self</span>
                        <br/>
                        <a>{CountSelf}</a>
                    </Item>
                </Badge>
            </IconButton> */}
            <IconButton onClick={(val) => handleStatusClick(datasource,8,"others")}>
                <Badge badgeContent={UnreadRejected} color="success"  style={{paddingLeft:"10px"}}>
                    <Item style={{fontSize:"11px",width:"150px",height:"50px", backgroundColor: currentstatus == 8 ? "lightgray" : "white"}}>
                        <span style={{ fontWeight: 'bold' }}>Rejected</span>
                        <br/>
                        <a>{CountRejected}</a>
                    </Item>
                </Badge>
            </IconButton>
            <IconButton onClick={(val) => handleStatusClick(datasource,0,"others")}>
                <Badge badgeContent={UnreadWaitApproval} color="success"  style={{paddingLeft:"10px"}}>
                    <Item style={{fontSize:"11px",width:"150px",height:"50px", backgroundColor: currentstatus == 0 ? "lightgray" : "white"}}>
                        <span style={{ fontWeight: 'bold' }}>Waiting Approval</span>
                        <br/>
                        <a>{CountWaitApproval}</a>
                    </Item>
                </Badge>
            </IconButton>
            
            <IconButton onClick={(val) => handleStatusClick(datasource,1,"others")}>
                <Badge badgeContent={UnreadWaitVerify} color="success"  style={{paddingLeft:"10px"}}>
                    <Item style={{fontSize:"11px",width:"150px",height:"50px", backgroundColor: currentstatus == 1 ? "lightgray" : "white"}}>
                        <span style={{ fontWeight: 'bold' }}>Pending Verify</span>
                        <br/>
                        <a>{CountWaitVerify}</a>
                    </Item>
                </Badge>
            </IconButton>
            
            <IconButton onClick={(val) => handleStatusClick(datasource,2,"others")}>
                <Badge badgeContent={UnreadWaitIssue} color="success"  style={{paddingLeft:"10px"}}>
                    <Item style={{fontSize:"11px",width:"150px",height:"50px", backgroundColor: currentstatus == 2 ? "lightgray" : "white"}}>
                        <span style={{ fontWeight: 'bold' }}>Ready To Issue</span>
                        <br/>
                        <a>{CountWaitIssue}</a>
                    </Item>
                </Badge>
            </IconButton>
            
            <IconButton onClick={(val) => handleStatusClick(datasource,3,"others")}>
                <Badge badgeContent={UnreadCompleted} color="success"  style={{paddingLeft:"10px"}}>
                    <Item style={{fontSize:"11px",width:"150px",height:"50px", backgroundColor: currentstatus == 3 ? "lightgray" : "white"}}>
                        <span style={{ fontWeight: 'bold' }}>Pending Completion</span>
                        <br/>
                        <a>{CountCompleted}</a>
                    </Item>
                </Badge>
            </IconButton>

            <IconButton hidden={userexportlist.includes(userid) == true ? false : true} onClick={(val) => handleStatusClick(datasource,4,"others")}>
                <Badge  color="success"  style={{paddingLeft:"10px"}}>
                    <Item style={{fontSize:"11px",width:"150px",height:"50px", backgroundColor: currentstatus == 4 ? "lightgray" : "white"}}>
                        <span style={{ fontWeight: 'bold' }}>Ready To Export</span>
                        <br/>
                        <a>{CountExport}</a>
                    </Item>
                </Badge>
            </IconButton>

            <IconButton onClick={(val) => handleStatusClick(datasource,5,"others")}>
                <Badge badgeContent={UnreadDone} color="success"  style={{paddingLeft:"10px"}}>
                    <Item style={{fontSize:"11px",width:"150px",height:"50px", backgroundColor: currentstatus == 5 ? "lightgray" : "white"}}>
                        <span style={{ fontWeight: 'bold' }}>Completed</span>
                        <br/>
                        <a>{CountDone}</a>
                    </Item>
                </Badge>
            </IconButton>
           
            <IconButton onClick={(val) => handleStatusClick(datasource,9,"others")}>
                <Badge badgeContent={UnreadCancel} color="success"  style={{paddingLeft:"10px"}}>
                    <Item style={{fontSize:"11px",width:"150px",height:"50px", backgroundColor: currentstatus == 9 ? "lightgray" : "white"}}>
                        <span style={{ fontWeight: 'bold' }}>Cancel</span>
                        <br/>
                        <a>{CountCancel}</a>
                    </Item>
                </Badge>
            </IconButton>
           
            </div>
        </Row>
           <br/>
           <Row>
               <div style={{width:"100%"}}>
                   {
                       currentstatus == -3 ?
                       <>
                        <Collapse   expandIconPosition={"right"} activeKey={collapse} onChange={onCollapse} >
                        <Panel header={CurrentDetailType == "edit" ? GetTranslation(userlang, "Edit Payment") : GetTranslation(userlang, "Create Payment")} key="1" >
                        
                            <div>
                                <Row>
                                <Col style={{width:"50%"}}>
                                <div style={{width:"100%"}}>
                                    <Autocomplete 
                                        // freeSolo
                                        value={Ctype}
                                        onChange={(val1,val2) => Ftypechange(val2,1)}
                                        options={paymenttypeselect}
                                        isOptionEqualToValue={(option, value) => option.value === value}
                                        renderInput={(params) => <TextField {...params} label="Payment Type" />}>

                                    </Autocomplete>
                                        
                                    </div>
                            </Col>
                            <Col style={{width:"50%"}}>
                            <LocalizationProvider  dateAdapter={AdapterDayjs}>
                                <Stack>
                                    <DesktopDatePicker
                                    
                                    disabled={CheaderData.length > 0 ? true:false}
                                    label= {GetTranslation(userlang,"Invoice Date")}
                                    value ={Cinvdate ? Cinvdate: null}
                                    onChange={Fpaydatechange}
                                    //minDate={dayjs()}
                                    inputFormat="YYYY/MM/DD"
                                    renderInput={(params) => <TextField {...params} />}
                                    >                        
                                    </DesktopDatePicker>
                                    </Stack>
                                </LocalizationProvider>
                            
                            </Col>
                               
                                </Row>
                           
                           {
                               Ctype == "CLAIM" ? 
                               <>
                               </>
                               :
                               <>
                                <div>
                                <br/>
                                <Autocomplete
                                    freeSolo
                                    value={Csupplier}
                                    onChange={(val1,val2) => Fsupplierchange(val2,1)}
                                    onInputChange={(val1,val2) => Fsupplierchange(val2,2)}
                                    inputValue={Csupplier}
                                    options={Mpayee}
                                    isOptionEqualToValue={(option, value) => option.value === value}
                                    renderInput={(params) => <TextField {...params} label="Payee" />}>

                                </Autocomplete>
                                </div>
                                <br/>
                                <Row>
                                    <Col style={{width:"40%"}}>
                                    <div style={{width:"100%"}}>
                        
                                        <TextField
                                        value={Csupplierdesc}
                                            style={{width:"100%"}}
                                            id="outlined-desc"
                                            label="Payee Desc"
                                            disabled={SBankCurrencyDisable}
                                            onChange={(val1) => setCsupplierdesc(val1.target.value.toUpperCase())}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        /> 
                                    </div>
                                    </Col>
                                <Col style={{width:"30%"}}>
                                <Autocomplete 
                                    freeSolo
                                    onChange={(val1,val2) => Fbankchange(val2,1)}
                                    onInputChange={(val1,val2) => Fbankchange(val2,2)}
                                    inputValue={Cbank}
                                    value={Cbank}
                                    disabled={SBankCurrencyDisable}
                                    options={bankselect}
                                    isOptionEqualToValue={(option, value) => option.value === value}
                                    renderInput={(params) => <TextField {...params} label="Bank" />}>

                                </Autocomplete>
                            
                                </Col>
                                <Col style={{width:"30%"}}>
                                <Autocomplete 
                                    freeSolo
                                    value={Ccurrency}
                                    disabled={SBankCurrencyDisable}
                                    onChange={(val1,val2) => Fcurrencychange(val2,1)}
                                    onInputChange={(val1,val2) => Fcurrencychange(val2,2)}
                                    inputValue={Ccurrency}
                                    options={currencyselect}
                                    isOptionEqualToValue={(option, value) => option.value === value}
                                    renderInput={(params) => <TextField {...params} label="Currency" />}>

                                </Autocomplete>
                                </Col>
                                </Row>
                             
                                <br/>
                                <Row>
                                    <div style={{width:"100%"}}>
                        
                                            <TextField
                                            value={Cbankacct}
                                                style={{width:"100%"}}
                                                id="outlined-desc"
                                                label="Bank Account"
                                                disabled={SBankCurrencyDisable}
                                                onChange={(val1) => setCbankacct(val1.target.value.toUpperCase())}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            /> 
                                        </div>
                                </Row>
                               </>
                           }
                           
                           
                            </div>
                            
                            <br/>
                            <Row>
                                <div style={{width:"100%"}}>
                
                                    <TextField
                                    value={Cdetail}
                                        style={{width:"100%"}}
                                        id="outlined-desc"
                                        label="Description"
                                        multiline
                                        onChange={(val1) => setCdetail(val1.target.value)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    /> 
                                    
                                </div>
                            </Row>
                            <br/>
                            <Row>
                                <div style={{width:"100%"}}>
                                    <TextField
                                        style={{width:"100%"}}
                                        id="outlined-remark"
                                        label="Remark"
                                        value={Cremark}
                                        onChange={(val1) => setCremark(val1.target.value)}
                                        multiline
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                            </Row>
                            <br/>
                            <Row>
                            
                            <Col style={{width:"100%"}}>
                                {/* <TextField
                                    style={{width:"100%"}}
                                    id="outlined-number"
                                    label="Amount"
                                    type="number"
                                    value={Camount}
                                    onChange={(val1) => setCamount(val1.target.value)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    /> */}
                                    <Button onClick={() => handleDetailListingOpen(1)} >
                                        {Cdetailitemsheader}
                                    </Button>
                            </Col>
                            </Row>
                            <br/>
                            <Row>
                                <div style={{display:"flex",justifyContent:"end",width:"80%"}}>
                                    <Button onClick={(val) => CreatePayment(2)}>{CurrentDetailType == "edit" ? GetTranslation(userlang, "Edit And Save Template") : GetTranslation(userlang, "Create And Save Template")}</Button>
                                </div>
                               
                                <div style={{display:"flex",justifyContent:"end",width:"20%"}}>
                                    <Button type='primary' onClick={(val) => CreatePayment(1)}>{CurrentDetailType == "edit" ? GetTranslation(userlang, "Edit") : GetTranslation(userlang, "Create")}</Button>
                                </div>                    
                            </Row>
                            <Row>
                                <div style={{width:"100%"}}>
                                    <Upload {...PaymentAttProps}>
                                        <Button icon={<UploadOutlined />}>Upload</Button>
                                    </Upload>
                                </div>
                            </Row>
                        </Panel>
                        <Panel header={GetTranslation(userlang, "Template")} key="2">
                            <div>
                                <Row>
                                    
                                <LocalizationProvider  dateAdapter={AdapterDayjs}>
                                        <Stack>
                                            <DesktopDatePicker
                                        
                                            label= {GetTranslation(userlang,"Invoice Date")}
                                            value ={Tinvdate ? Tinvdate: null}
                                            onChange={Tpaydatechange}
                                            //minDate={dayjs()}
                                            inputFormat="YYYY/MM/DD"
                                            renderInput={(params) => <TextField {...params} />}
                                            >                        
                                            </DesktopDatePicker>
                                        </Stack>
                                    </LocalizationProvider>
                                   
                                    
                                    &nbsp; &nbsp;
                                    <Button disabled={ButtonTemplateDisable} onClick={(val) => CreatePayment(3)}>Create</Button>
                                   
                                </Row>
                           
                            </div>
                            <Table
                            bordered
                            components={components}
                            rowClassName={() => 'editable-row'}
                            rowSelection={{
                                type: selectionType,
                                ...rowSelection,
                              }}
                            dataSource={[...FULLtemplte]}
                            columns={templatecolumns}
                            scroll={{
                                x: 1000,
                              }}>

                            </Table>
                        </Panel>
                        </Collapse>
                       </>
                       :
                       <>
                      
                            <div>
                                {
                                    currentstatus == -1 ?
                                    <>
                                    <Button disabled={ButtonDisable} onClick={(val) => UpdatePaymentStatus(9,"Cancel",0)}>Cancel</Button>
                                    </>
                                    :
                                    currentstatus == 0 ?
                                    <>
                                    <Button disabled={ButtonDisable} onClick={(val) => UpdatePaymentStatus(1,"Approve",0)}>Approve</Button>
                                    &nbsp;&nbsp;&nbsp;
                                    <Button disabled={ButtonDisable} onClick={(val) => UpdatePaymentStatus(8,"Reject",0)}>Reject</Button>
                                    </>
                                    :
                                    currentstatus == 1 ?
                                    <>
                                    <Button disabled={ButtonDisable} onClick={(val) => UpdatePaymentStatus(2,"Verify",0)}>Verify</Button>
                                    &nbsp;&nbsp;&nbsp;
                                    <Button disabled={ButtonDisable} onClick={(val) => UpdatePaymentStatus(8,"Reject",0)}>Reject</Button>
                                    </>
                                    : 
                                    currentstatus == 2 ?
                                    <>
                                    {
                                        userissuelist.includes(userid) == true ?
                                        <>
                                         <div>
                                        <Row>
                                            <LocalizationProvider  dateAdapter={AdapterDayjs}>
                                                <Stack>
                                                    <DesktopDatePicker
                                                    disabled ={ButtonPaydateDisable}
                                                    label= {GetTranslation(userlang,"Pay Date")}
                                                    value ={Ipaydate ? Ipaydate: null}
                                                    onChange={Ipaydatechange}
                                                    minDate={dayjs()}
                                                    inputFormat="YYYY/MM/DD"
                                                    renderInput={(params) => <TextField {...params} />}
                                                    >                        
                                                    </DesktopDatePicker>
                                                </Stack>
                                            </LocalizationProvider>
                                            &nbsp;&nbsp;&nbsp;
                                            <Button disabled={ButtonDisable} onClick={(val) => UpdatePaymentStatus(3,"Issue",0)}>Issue</Button>
                                            &nbsp;&nbsp;&nbsp;
                                            <Button disabled={ButtonDisable} onClick={(val) => UpdatePaymentStatus(8,"Reject",0)}>Reject</Button>
                                        
                                        </Row>
                                        <br/>
                                        <Row>
                                        <Autocomplete 
                                            style={{width:"300px"}}
                                            value={Ipayid}
                                            onChange={(val1,val2) => Ipayidchange(val2,1)}
                                            options={Mpaymentacct}
                                            isOptionEqualToValue={(option, value) => option.value === value}
                                            renderInput={(params) => <TextField {...params} label="Payment" />}>

                                        </Autocomplete>
                                        </Row>
                                            </div>
                                            </>
                                        :
                                        <></>
                                    }
                                   
                                    </>
                                    : 
                                    currentstatus == 3 ?
                                    <>
                                    {
                                        usercompletelist.includes(userid) == true ?
                                        <>
                                          <Button disabled={ButtonDisable} onClick={(val) => UpdatePaymentStatus(4,"Complete",0,'',datasourceByStatus)}>Complete</Button>
                                            &nbsp;&nbsp;&nbsp;
                                            <Button disabled={ButtonDisable} onClick={(val) => UpdatePaymentStatus(8,"Reject",0)}>Reject</Button>
                                        </>
                                        :
                                        <></>
                                    }
                                   </>
                                    // : 
                                    // currentstatus == 4 ?
                                    // <>
                                    // <Button disabled={ButtonDisable} onClick={(val) => UpdatePaymentStatus(5,"Export",0)}>Export</Button>
                                    // </>
                                    : 
                                    currentstatus == 8 ?
                                    <>
                                    <Button disabled={ButtonDisable} onClick={(val) => UpdatePaymentStatus(9,"Cancel",0)}>Cancel</Button>
                                    </>
                                    : 
                                    <></>
                                }
                            </div>
                            <div>
                                {
                                    currentstatus == -2 || 
                                    (currentstatus == 2 && userissuelist.includes(userid) == false) ||
                                    currentstatus == 3 || 
                                    currentstatus == 4 || 
                                    currentstatus == 5 ||  
                                    currentstatus == 9 ?
                                    <>
                                    </>
                                    :
                                    <>
                                    <Checkbox disabled={CheckAlldisable}
                                        indeterminate={CheckAllIndeterminate} 
                                        checked={CheckAllchecked}
                                        onClick={(e) => CheckAllFunction()}>Check All
                                        </Checkbox>
                                    </>
                                }
                                
                            </div>
                            <div style={{ height: winheight * 0.6 +"px", width: '100%', overflowY: "auto",overflowX: "hidden", paddingBottom:"50px" }}>
                                {/* <DataGrid
                                        rows={datasource}
                                        columns={columns}
                                        getRowHeight={() => 'auto'}
                                        checkboxSelection
                                        onSelectionModelChange={(itm) => setActionCheckList(itm)}
                                /> */}
                                {
                                    (currentstatus == 3 && usercompletelist.includes(userid))  ?
                                    <>
                                    <List
                                    size='small'
                                    bordered
                                    dataSource={datasourceByStatus}
                                    renderItem={(item) => (
                                        <List.Item>
                                             <List.Item.Meta
                                             title={
                                                 <>
                                                 <div style={{backgroundColor: item.userunread == true ? "lemonchiffon" : "white",borderRadius: '5px', padding: '5px', border: '1px solid #ddd', margin: '5px'}}>
                                                                     
                                                                 
                                                 <div style={{width:"85%",display:"inline-flex" }}>
                                                     {
                                                         item.issueruserlists ? 
                                                         <>
                                                          <Checkbox indeterminate={item.isInderterminate ? true : false} checked={item.isChecked ? true : false} onClick={(val1) => handleCheckListClick(item._id,val1,item,"check all")}>                              
                                                        <h1>{item.label}</h1>
                                                        {/* {
                                                            currentstatus == 3 ?
                                                            <>
                                                             <br/>
                                                            <small>Paydate : {moment.unix(item.paydate).format("DD-MMM")}, Remain : {moment(moment.unix(item.paydate)).diff(moment(),"days")} days</small>
                                                            </>
                                                            :
                                                            <>
                                                             <br/>
                                                            <small>Completed : {moment.unix(item.paydate).format("DD-MMM")}</small>
                                                            
                                                            </>
                                                        } */}
                                                        <small>Total Transaction : <a style={{color:"red"}}>{item.detailitems.length}</a></small>
                                                       
                                                        </Checkbox>
                                                         </>
                                                         :
                                                         <>
                                                         <h1>{item.label}</h1>
                                                         </>
                                                     }
                                                
                                                 </div>
                                                 <small style={{width:"15%",display:"inline-flex", justifyContent:"end"}}>
                                                     {
                                                         item.issueruserlists ?
                                                         <>
                                                           <a onClick={() => handleListClick(item,2)}>{item.totalamount ? item.totalamount.toLocaleString(undefined, {maximumFractionDigits:2}) : 0}</a>
                                                            {item.isOpen ?
                                                            <ExpandLess onClick={() => handleListClick(item,2)} /> 
                                                            : 
                                                            <ExpandMore onClick={() => handleListClick(item,2)}/>}

                                                         </>
                                                         :
                                                         <></>
                                                     }
                                                  
                                                    </small>
                                                    </div>
                                                    <CollapseMUI in={item.isOpen} timeout="auto" unmountOnExit>
                                                    <List
                                                    size='small'
                                                    bordered
                                                    dataSource={item.issueruserlists}
                                                    renderItem={(items) => (
                                                        <List.Item>
                                                             <List.Item.Meta
                                                             title = {
                                                                 <>
                                                               
                                                                  <div style={{backgroundColor:items.userunread == true ? "lemonchiffon" : ""}}>
                                                                 
                                                                    <div style={{display:"inline-block", width:"70%"}}>
                                                                    <Checkbox checked={items.isChecked ? true : false} onClick={(val1) => handleCheckListClick(items._id,val1,item)}>
                                                                    <div>
                                                                    <small 
                                                                        style={{
                                                                            backgroundColor : "rgb(41,144,64)",
                                                                            color:"white",
                                                                            paddingLeft:"3px",
                                                                            paddingRight:"3px",
                                                                            marginRight:"3px",
                                                                            fontWeight:"bold"
                                                                        }}>{"ISSUER"}</small>
                                                                    
                                                                            <small>
                                                                            {`${items.issuebyname}`}
                                                                            </small>                                               
                                                                       
                                                                    </div>
                                                                    
                                                                    <div>
                                                                    <small>Total Transaction : <a style={{color:"red"}}>{items.detailitems.length}</a></small>
                                                                    </div>
                                                                 
                                                                    </Checkbox>
                                                                    </div>
                                                                     
                                                                 
                                                                    <div style={{display:"inline-grid", width:"10%",justifyContent:"end"}}>
                                                                        
                                                                    {
                                                                        items.isWarning == true && items.paytype != 'CLAIM' && currentstatus != 5 ?
                                                                        <>
                                                                        <IconButton onClick={() => handleModalHistoryOpen(items)}>
                                                                        <WarningAmberIcon style={{color : "red"}}></WarningAmberIcon>
                                                                        </IconButton>
                                                                        
                                                                        </>
                                                                        :
                                                                        items.paytype != 'CLAIM' && currentstatus != 5 ?
                                                                        <>
                                                                        <IconButton onClick={() => handleModalHistoryOpen(items)}>
                                                                        <HistoryIcon style={{color : "#006633"}}></HistoryIcon>
                                                                        </IconButton>
                                                                        </>
                                                                        :
                                                                        <>
                                                                        </>
                                                                    }
                                                                
                                                                    </div>
                                                                 <small style={{display:"inline-flex", width:"20%",justifyContent:"end"}}>
                                                                    
                                                                    <a onClick={() => handleListClick(items,4)}>{items.totalamount.toLocaleString(undefined, {maximumFractionDigits:2})}</a>
                                                                    {items.isOpen ?
                                                                    <ExpandLess onClick={() => handleListClick(items,4)} /> 
                                                                    : 
                                                                    <ExpandMore onClick={() => handleListClick(items,4)}/>}
                                                                    </small>
                                                                    </div>
                                                                    <CollapseMUI in={items.isOpen} timeout="auto" unmountOnExit>
                                                                    <List
                                                                    size='small'
                                                                    bordered
                                                                    dataSource={items.detailitems}
                                                                    renderItem={(itemss) => (
                                                                        <List.Item>
                                                                            <List.Item.Meta
                                                                            title = {
                                                                                <>
                                                                            
                                                                                <div style={{backgroundColor:itemss.userunread == true ? "lemonchiffon" : ""}}>
                                                                                
                                                                                    <div style={{display:"inline-block", width:"70%"}}>
                                                                                    <Checkbox checked={itemss.isChecked ? true : false} onClick={(val1) => handleCheckListClick(items._id,val1,item)}>
                                                                                    <div>
                                                                                    <small 
                                                                                        style={{
                                                                                            backgroundColor :itemss.createdby == userid ? "rgb(255, 153, 0)" : "rgb(41,144,64)",
                                                                                            color:"white",
                                                                                            paddingLeft:"3px",
                                                                                            paddingRight:"3px",
                                                                                            marginRight:"3px",
                                                                                            fontWeight:"bold"
                                                                                        }}>{itemss.createdby == userid ? "SELF" : "FROM"}</small>
                                                                                    {
                                                                                        itemss.createdby == userid ?
                                                                                            <>
                                                                                            </>
                                                                                            :
                                                                                            <>
                                                                                            <small>
                                                                                            {`${itemss.createdbyname} - `}
                                                                                            </small>
                                                                                        </>                                                   }
                                                                                        <small><small style={{color:"green", fontSize:"13px"}}>{itemss.title}</small></small>
                                                                                    </div>
                                                                                    
                                                                                    <div>
                                                                                        <small>Payee : <small style={{color:"green", fontSize:"13px"}}>{itemss.paytype == "CLAIM" ? itemss.paytype : itemss.payee +' - ' + itemss.payeedesc}</small></small>
                                                                                    </div>
                                                                                
                                                                                    <div>
                                                                                        <small>Paydate : <small style={{color:"green", fontSize:"13px"}}>{moment.unix(itemss.paydate).format("DD-MMM")}</small>,
                                                                                        Remain : <small style={{color:moment(moment.unix(itemss.paydate)).diff(moment(),"days") > 0 ? "green" : "red", fontSize:"13px"}}>{moment(moment.unix(itemss.paydate)).diff(moment(),"days")} days</small></small>
                                                                                    </div>
                                                                                    </Checkbox>
                                                                                    </div>
                                                                                    
                                                                                
                                                                                    <div style={{display:"inline-grid", width:"10%",justifyContent:"end"}}>
                                                                                        {
                                                                                    itemss.status == 8 && itemss.createdby == userid ?
                                                                                    <>
                                                                                
                                                                                    <IconButton onClick={() => handleEditClick(item)}>
                                                                                        <EditIcon>

                                                                                        </EditIcon>
                                                                                    </IconButton>
                                                                                
                                                                                    </>
                                                                                    :
                                                                                    <>
                                                                                    </>
                                                                                    }
                                                                                    {
                                                                                        itemss.isWarning == true && itemss.paytype != 'CLAIM' && currentstatus != 5 ?
                                                                                        <>
                                                                                        <IconButton onClick={() => handleModalHistoryOpen(items)}>
                                                                                        <WarningAmberIcon style={{color : "red"}}></WarningAmberIcon>
                                                                                        </IconButton>
                                                                                        
                                                                                        </>
                                                                                        :
                                                                                        itemss.paytype != 'CLAIM' && currentstatus != 5 && itemss.history.length > 0 ?
                                                                                        <>
                                                                                        <IconButton onClick={() => handleModalHistoryOpen(items)}>
                                                                                        <HistoryIcon style={{color : "#006633"}}></HistoryIcon>
                                                                                        </IconButton>
                                                                                        </>
                                                                                        :
                                                                                        <>
                                                                                        </>
                                                                                    }
                                                                                
                                                                                    </div>
                                                                                <small style={{display:"inline-flex", width:"20%",justifyContent:"end"}}>
                                                                                    
                                                                                    <a onClick={() => handleListClick(itemss,3)}>{itemss.totalamount.toLocaleString(undefined, {maximumFractionDigits:2})}</a>
                                                                                    {itemss.isOpen ?
                                                                                    <ExpandLess onClick={() => handleListClick(itemss,3)} /> 
                                                                                    : 
                                                                                    <ExpandMore onClick={() => handleListClick(itemss,3)}/>}
                                                                                    </small>
                                                                                    </div>
                                                                                    
                                                                                    <CollapseMUI in={itemss.isOpen} timeout="auto" unmountOnExit>
                                                                                    {/* <List component="div" disablePadding>
                                                                                    <ListItemButton sx={{ pl: 4 }}>
                                                                                        <ListItemText primary={item.description} />
                                                                                    </ListItemButton>
                                                                                    </List> */}
                                                                                    <List component="div">
                                                                                
                                                                                    <div>{showAttachmentList(itemss)}</div>
                                                                                    <br/> 
                                                                                    <Row style={{lineHeight:"0.8"}}>
                                                                                        <Col style={{width:"90px"}}>
                                                                                            <div>
                                                                                                <span style={{color:"black",backgroundColor:"lightblue"}}>
                                                                                                {`Description : `}  
                                                                                                </span>
                                                                                            
                                                                                            </div>
                                                                                        </Col>
                                                                                        <Col >
                                                                                            <div>
                                                                                                <Paragraph  className="textparagraph">{itemss.description}</Paragraph>
                                                                                            </div>
                                                                                    </Col>
                                                                                    </Row>
                                                                                    <br/>
                                                                                    <Row style={{lineHeight:"0.8"}}>
                                                                                        <Col style={{width:"90px"}}>
                                                                                            <div >
                                                                                                <span style={{color:"black",backgroundColor:"lightblue"}}>
                                                                                                {`Remarks : `}    
                                                                                                </span>
                                                                                            
                                                                                            </div>
                                                                                        </Col>
                                                                                        <Col >
                                                                                            <div>
                                                                                                <Paragraph  className="textparagraph">{itemss.remarks}</Paragraph>
                                                                                            </div>
                                                                                    </Col>
                                                                                    </Row>
                                                                                    <br/>

                                                                                    <TableContainer component={Paper}>
                                                                                        <TableMUI  aria-label='Header Text'>
                                                                                            <TableHead>
                                                                                                <TableRow  sx={{
                                                                                                        padding: "0px 0px",
                                                                                                        borderRight: "2px solid black",
                                                                                                        backgroundColor: "lightblue",
                                                                                                        fontSize: "1.2rem"
                                                                                                        
                                                                                                    }}>
                                                                                                    <TableCell>Item Type</TableCell>
                                                                                                    <TableCell>Description</TableCell>
                                                                                                    <TableCell>Qty</TableCell>
                                                                                                    <TableCell>Price / Unit</TableCell>
                                                                                                    <TableCell>Subtotal</TableCell>
                                                                                                    {/* <TableCell>Pay Date</TableCell>
                                                                                                    <TableCell>Created By</TableCell> */}
                                                                                                    {/* <TableCell>Attachements</TableCell> */}
                                                                                                    {/* <TableCell>Last Payment</TableCell> */}
                                                                                                </TableRow>
                                                                                            </TableHead>
                                                                                            <TableBody>
                                                                                                {datasourceDetail2.map((row) =>
                                                                                                <TableRow
                                                                                                    key={row.Did}
                                                                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                                                                    <TableCell component="th" scope="row">{row.Ditemtype}</TableCell>
                                                                                                    <TableCell>{row.Ddescription}</TableCell>
                                                                                                    <TableCell>{row.Dqty.toLocaleString(undefined, {maximumFractionDigits:2})}</TableCell>
                                                                                                    <TableCell>{row.Dpriceunit.toLocaleString(undefined, {maximumFractionDigits:2})}</TableCell>
                                                                                                    <TableCell>{row.Dtotalprice.toLocaleString(undefined, {maximumFractionDigits:2})}</TableCell>
                                                                                                    {/* <TableCell>{moment.unix(row.pdate).format("MMM-DD")}</TableCell>
                                                                                                    <TableCell>{row.createdby}</TableCell> */}
                                                                                                    {/* <TableCell align='center'>
                                                                                                        {row.pfilelist.length > 0 ?
                                                                                                        <a onClick={(val) => Fopendetailupload2(row)}>
                                                                                                        {row.pfilelist.length}
                                                                                                        </a>
                                                                                                        :
                                                                                                        <span>
                                                                                                            -
                                                                                                        </span>
                                                                                                        } 
                                                                                                        
                                                                                                    </TableCell> */}
                                                                                                    {/* <TableCell>2022-12-29 <br/> 5,000</TableCell> */}
                                                                                                </TableRow>
                                                                                                
                                                                                                )}
                                                                                                {/* <TableRow>
                                                                                                    <TableCell colSpan={2}>Total :</TableCell>
                                                                                                    <TableCell align="right">{datasourceDetailTotal.toLocaleString(undefined, {maximumFractionDigits:2})}</TableCell>
                                                                                                </TableRow> */}
                                                                                            </TableBody>
                                                                                        </TableMUI>
                                                                                    </TableContainer>  
                                                                                    </List>
                                                                                    
                                                                                </CollapseMUI>
                                                                                </>
                                                                            }>

                                                                            </List.Item.Meta>
                                                                        </List.Item>
                                                                            
                                                                            )}>
                                                                    </List>
                                                                    </CollapseMUI>
                                                                 </>
                                                             }>

                                                             </List.Item.Meta>
                                                        </List.Item>
                                                             
                                                             )}>
                                                    </List>
                                                    </CollapseMUI>
                                                   
                                                 </>
                                                 
                                             }>

                                             </List.Item.Meta>
                                        </List.Item>
                                    )}>

                                    </List>
                                    </>
                                    :
                                    currentstatus == 4 ?
                                    <>
                                    <List
                                    size='small'
                                    bordered
                                    dataSource={datasourceByStatus}
                                    renderItem={(item) => (
                                        <List.Item>
                                             <List.Item.Meta
                                             title={
                                                 <>
                                                 <div style={{backgroundColor: item.userunread == true ? "white" : "white",borderRadius: '5px', padding: '5px', border: '1px solid #ddd', margin: '5px'}}>
                                                                     
                                                                 
                                                 <div style={{width:"75%",display:"inline-flex" }}>
                                        
                                                          <div>                              
                                                        <h1>{item.payid}</h1>
                                                        <small>Payment Acct :  <a style={{color:"red"}}>{item.paymentacct}</a></small>
                                                        <br/>
                                                        <small>Total Transaction : <a style={{color:"red"}}>{item.detailitems.length}</a></small>
                                                        <br/>
                                                        <small>Completed At : <a style={{color:"red"}}>{moment.unix(item.completeddate).format("DD-MMM")}</a></small>
                                                       
                                                        </div>
                                                  
                                                 </div>
                                                 <div style={{display:"inline-block", width:"10%",justifyContent:"end"}}>
                                                    
                                                         <IconButton>
                                                             <FileDownloadIcon>

                                                             </FileDownloadIcon>
                                                             </IconButton>
                                                </div>
                                                 <small style={{width:"15%",display:"inline-flex", justifyContent:"end"}}>
                                                     {
                                                         item.detailitems ?
                                                         <>
                                                           <a onClick={() => handleListClick(item,2)}>{item.totalamount ? item.totalamount.toLocaleString(undefined, {maximumFractionDigits:2}) : 0}</a>
                                                            {item.isOpen ?
                                                            <ExpandLess onClick={() => handleListClick(item,2)} /> 
                                                            : 
                                                            <ExpandMore onClick={() => handleListClick(item,2)}/>}

                                                         </>
                                                         :
                                                         <></>
                                                     }
                                                  
                                                    </small>
                                                    </div>
                                                    <CollapseMUI in={item.isOpen} timeout="auto" unmountOnExit>
                                                    <List
                                                    size='small'
                                                    bordered
                                                    dataSource={item.detailitems}
                                                    renderItem={(items) => (
                                                        <List.Item>
                                                             <List.Item.Meta
                                                             title = {
                                                                <>
                                                              
                                                                 <div style={{backgroundColor:items.userunread == true ? "lemonchiffon" : ""}}>
                                                                
                                                                   <div style={{display:"inline-block", width:"85%"}}>
                                                                   <div>
                                                                   <small 
                                                                        style={{
                                                                            backgroundColor :items.createdby == userid ? "rgb(255, 153, 0)" : "rgb(41,144,64)",
                                                                            color:"white",
                                                                            paddingLeft:"3px",
                                                                            paddingRight:"3px",
                                                                            marginRight:"3px",
                                                                            fontWeight:"bold"
                                                                        }}>{items.createdby == userid ? "SELF" : "FROM"}</small>
                                                                    {
                                                                        items.createdby == userid ?
                                                                            <>
                                                                            </>
                                                                            :
                                                                            <>
                                                                            <small>
                                                                            {`${items.createdbyname} - `}
                                                                            </small>
                                                                        </>                                                   }
                                                                       <small><small style={{color:"green", fontSize:"13px"}}>{items.title}</small></small>
                                                                   </div>
                                                                   
                                                                   <div>
                                                                       <small>Payee : <small style={{color:"green", fontSize:"13px"}}>{items.paytype == "CLAIM" ? item.paytype : items.payee +' - ' + items.payeedesc}</small></small>
                                                                   </div>
                                                                  
                                                                   </div>
                                                                     
                                                                 
                                                                 {/* <div style={{display:"inline-block", width:"10%",justifyContent:"end"}}>
                                                                     {
                                                                         currentstatus == 3 ? 
                                                                         <>
                                                                          <Popconfirm title="Sure to delete?" onConfirm={() => UpdatePaymentStatus(2,"",3,items._id,items)}>
                                                                              <IconButton>
                                                                                  <DeleteForeverIcon>

                                                                                  </DeleteForeverIcon>
                                                                                </IconButton>
                                                                            </Popconfirm>
                                                                
                                                                         </>
                                                                         :
                                                                         <>
                                                                         </>
                                                                     }
                                                                
                                                                 </div> */}
                                                                 <small style={{display:"inline-flex", width:"15%",justifyContent:"end"}}>
                                                                    
                                                                    <a onClick={() => handleListClick(items,3)}>{items.totalamount.toLocaleString(undefined, {maximumFractionDigits:2})}</a>
                                                                    {items.isOpen ?
                                                                    <ExpandLess onClick={() => handleListClick(items,3)} /> 
                                                                    : 
                                                                    <ExpandMore onClick={() => handleListClick(items,3)}/>}
                                                                    </small>
                                                                    </div>
                                                                    
                                                                    <CollapseMUI in={items.isOpen} timeout="auto" unmountOnExit>
                                                                    {/* <List component="div" disablePadding>
                                                                    <ListItemButton sx={{ pl: 4 }}>
                                                                        <ListItemText primary={item.description} />
                                                                    </ListItemButton>
                                                                    </List> */}
                                                                    <List component="div">
                                                                   
                                                                    <div>{showAttachmentList(items)}</div>
                                                                    <br/> 
                                                                    <Row style={{lineHeight:"0.8"}}>
                                                                        <Col style={{width:"90px"}}>
                                                                            <div>
                                                                                <span style={{color:"black",backgroundColor:"lightblue"}}>
                                                                                {`Description : `}  
                                                                                </span>
                                                                            
                                                                            </div>
                                                                        </Col>
                                                                        <Col >
                                                                            <div>
                                                                                <Paragraph  className="textparagraph">{items.description}</Paragraph>
                                                                            </div>
                                                                    </Col>
                                                                    </Row>
                                                                    <br/>
                                                                    <Row style={{lineHeight:"0.8"}}>
                                                                        <Col style={{width:"90px"}}>
                                                                            <div >
                                                                                <span style={{color:"black",backgroundColor:"lightblue"}}>
                                                                                {`Remarks : `}    
                                                                                </span>
                                                                            
                                                                            </div>
                                                                        </Col>
                                                                        <Col >
                                                                            <div>
                                                                                <Paragraph  className="textparagraph">{items.remarks}</Paragraph>
                                                                            </div>
                                                                    </Col>
                                                                    </Row>
                                                                    <br/>

                                                                    <TableContainer component={Paper}>
                                                                        <TableMUI  aria-label='Header Text'>
                                                                            <TableHead>
                                                                                <TableRow  sx={{
                                                                                        padding: "0px 0px",
                                                                                        borderRight: "2px solid black",
                                                                                        backgroundColor: "lightblue",
                                                                                        fontSize: "1.2rem"
                                                                                        
                                                                                    }}>
                                                                                    <TableCell>Item Type</TableCell>
                                                                                    <TableCell>Description</TableCell>
                                                                                    <TableCell>Qty</TableCell>
                                                                                    <TableCell>Price / Unit</TableCell>
                                                                                    <TableCell>Subtotal</TableCell>
                                                                                    {/* <TableCell>Pay Date</TableCell>
                                                                                    <TableCell>Created By</TableCell> */}
                                                                                    {/* <TableCell>Attachements</TableCell> */}
                                                                                    {/* <TableCell>Last Payment</TableCell> */}
                                                                                </TableRow>
                                                                            </TableHead>
                                                                            <TableBody>
                                                                                {datasourceDetail2.map((row) =>
                                                                                <TableRow
                                                                                    key={row.Did}
                                                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                                                    <TableCell component="th" scope="row">{row.Ditemtype}</TableCell>
                                                                                    <TableCell>{row.Ddescription}</TableCell>
                                                                                    <TableCell>{row.Dqty.toLocaleString(undefined, {maximumFractionDigits:2})}</TableCell>
                                                                                    <TableCell>{row.Dpriceunit.toLocaleString(undefined, {maximumFractionDigits:2})}</TableCell>
                                                                                    <TableCell>{row.Dtotalprice.toLocaleString(undefined, {maximumFractionDigits:2})}</TableCell>
                                                                                    {/* <TableCell>{moment.unix(row.pdate).format("MMM-DD")}</TableCell>
                                                                                    <TableCell>{row.createdby}</TableCell> */}
                                                                                    {/* <TableCell align='center'>
                                                                                        {row.pfilelist.length > 0 ?
                                                                                        <a onClick={(val) => Fopendetailupload2(row)}>
                                                                                        {row.pfilelist.length}
                                                                                        </a>
                                                                                        :
                                                                                        <span>
                                                                                            -
                                                                                        </span>
                                                                                        } 
                                                                                        
                                                                                    </TableCell> */}
                                                                                    {/* <TableCell>2022-12-29 <br/> 5,000</TableCell> */}
                                                                                </TableRow>
                                                                                
                                                                                )}
                                                                                {/* <TableRow>
                                                                                    <TableCell colSpan={2}>Total :</TableCell>
                                                                                    <TableCell align="right">{datasourceDetailTotal.toLocaleString(undefined, {maximumFractionDigits:2})}</TableCell>
                                                                                </TableRow> */}
                                                                            </TableBody>
                                                                        </TableMUI>
                                                                    </TableContainer>  
                                                                    </List>
                                                                    
                                                                </CollapseMUI>
                                                                 </>
                                                             }>

                                                             </List.Item.Meta>
                                                        </List.Item>
                                                             
                                                             )}>
                                                    </List>
                                                    </CollapseMUI>
                                                 </>
                                                 
                                             }>

                                             </List.Item.Meta>
                                        </List.Item>
                                    )}>

                                    </List>
                                    </>
                                    :
                                    <>
                                    <List
                                    size="small"
                                    bordered
                                    dataSource={datasourceByStatus}
                                    //onChange={(val1) =>handleDatasourceBystatus(datasourceByStatus)}
                                    renderItem={(item) => (
                                        <List.Item
                                            // actions={[
                                            // <a  onClick={(val) => { handleCancelTagUser(item,items.userid)}} 
                                            // style={{backgroundColor:"#f0f2f5", color:"red",  fontSize:"16px", display:`${item.createdby}` == userid ? "block" : "none"}}>Del</a>]}
                                            >
                                        
                                            <List.Item.Meta
                                            title={
                                            <>
                                            <div style={{backgroundColor:item.userunread == true ? "lemonchiffon" : "white", borderRadius: '5px', padding: '5px', border: '1px solid #ddd', margin: '5px' }}>
                                            <div style={{display:"inline-flex", width:"70%"}} >
                                                    {
                                                        (currentstatus == -2 || currentstatus == 9) ||
                                                        (currentstatus == 0 && item.checkapprove == false) ||
                                                        (currentstatus == 1 && item.checkverify == false) ||
                                                        (currentstatus == 2 && item.checkissue == false) ||
                                                        (currentstatus == 3 && item.checkcomplete == false) ||
                                                        (currentstatus == 5) ||
                                                        (currentstatus == 8 && item.checkcancel == false) ?
                                                        <>
                                                        <div>
                                                            <small 
                                                            style={{
                                                                backgroundColor :item.createdby == userid ? "rgb(255, 153, 0)" : "rgb(41,144,64)",
                                                                color:"white",
                                                                paddingLeft:"3px",
                                                                paddingRight:"3px",
                                                                marginRight:"3px",
                                                                fontWeight:"bold"
                                                            }}>{item.createdby == userid ? "SELF" : "FROM"}</small>
                                                        {
                                                            item.createdby == userid ?
                                                                <>
                                                                </>
                                                                :
                                                                <>
                                                                <small>
                                                                {`${item.createdbyname} - `}
                                                                </small>
                                                                </>                                                   }
                                                        <small>{item.title}</small>
                                                        <br/>
                                                        <small> Payee : {item.paytype == "CLAIM" ? item.paytype : item.payee +' - ' + item.payeedesc}</small>
                                                        <br/>
                                                        <a style={{color:
                                                        item.status == 0 ? "#006633" : 
                                                        item.status == 1 ? "#006633" : 
                                                        item.status == 2 ? "#006633" : 
                                                        item.status == 3 ? "#006633" : 
                                                        item.status == 4 ? "#006633" : 
                                                        item.status == 8 ? "#006633" : 
                                                        item.status == 9 ? "red" : ""}}>
                                                           {
                                                        item.status == 0 ? <small>{`Pending ${item.approvedbyname} Approval`}</small> : 
                                                        item.status == 1 ? <small>{`Pending ${item.verifybyname} Verify`}</small> : 
                                                        item.status == 2 ? <small>{"Ready To Issue"}</small> :
                                                        item.status == 3 ? <small>{"Waiting To Complete"}</small> : 
                                                        item.status == 4 ? <small>{`Completed on ${moment.unix(item.completeddate).format("DD-MMM")}`}</small> : 
                                                        item.status == 8 ? item.createdby == userid ? <> <small>Rejected by {item.rejectby == userid ? "you" : item.rejectbyname} on {moment.unix(item.rejectdate).format("DD-MMM")}</small></> : <small>{`Rejected by ${item.rejectby == userid ? "you" : item.rejectbyname} on ${moment.unix(item.rejectdate).format("DD-MMM")}`}</small> : 
                                                        item.status == 9 ? <small>{`Canceled on ${moment.unix(item.canceldate).format("DD-MMM")}`}</small> : ""
                                                        }</a>
                                                       
                                                        </div>
                                                       
                                                        
                                                        </>
                                                        :
                                                        <>
                                                        <Checkbox  checked={item.isChecked ? true : false} onClick={(val1) => handleCheckListClick(item._id,val1)}>
                                                        <small 
                                                            style={{
                                                                backgroundColor :item.createdby == userid ? "rgb(255, 153, 0)" : "rgb(41,144,64)",
                                                                color:"white",
                                                                paddingLeft:"3px",
                                                                paddingRight:"3px",
                                                                marginRight:"3px",
                                                                fontWeight:"bold"
                                                            }}>{item.createdby == userid ? "SELF" : "FROM"}</small>
                                                        {
                                                            item.createdby == userid ?
                                                                <>
                                                                </>
                                                                :
                                                                <>
                                                                <small>
                                                                    {`${item.createdbyname} - `}
                                                                </small>
                                                                </>                                                   }
                                                        <small>{item.title}</small>
                                                        <br/>
                                                        <small> Payee : {item.paytype == "CLAIM" ? item.paytype : item.payee +' - ' + item.payeedesc}</small>
                                                        <br/>
                                                        <a style={{color:
                                                        item.status == 0 ? "#006633" : 
                                                        item.status == 1 ? "#006633" : 
                                                        item.status == 2 ? "#006633" : 
                                                        item.status == 3 ? "#006633" : 
                                                        item.status == 4 ? "#006633" : 
                                                        item.status == 8 ? "#006633" : 
                                                        item.status == 9 ? "red" : ""}}>
                                                            {
                                                        item.status == 0 ? <small>{`Pending ${item.approvedbyname} Approval`}</small> : 
                                                        item.status == 1 ? <small>{`Pending ${item.verifybyname} Verify`}</small> : 
                                                        item.status == 2 ? <small>{"Ready To Issue"}</small> :
                                                        item.status == 3 ? <small>{"Waiting To Complete"}</small> : 
                                                        item.status == 4 ?<small>{`Completed on ${moment.unix(item.completeddate).format("DD-MMM")}`}</small> : 
                                                        item.status == 8 ? item.createdby == userid ? <> <small>Rejected by {item.rejectby == userid ? "you" : item.rejectbyname} on {moment.unix(item.rejectdate).format("DD-MMM")}</small></> : <small>{`Rejected by ${item.rejectby == userid ? "you" : item.rejectbyname} on ${moment.unix(item.rejectdate).format("DD-MMM")}`}</small> : 
                                                        item.status == 9 ? <small>{`Canceled on ${moment.unix(item.canceldate).format("DD-MMM")}`}</small> : ""
                                                        }</a>
                                                        </Checkbox>
                                                        </>
                                                    }
                                                   
                                                    
                                                    {/* &nbsp;&nbsp;
                                                    <a onClick={(val) => handleCheckListClick(item._id)}>{item.payee}</a> */}
                                                    </div >
                                                    <div style={{display:"inline-grid", width:"10%",justifyContent:"end"}}>
                                                         {
                                                    item.status == 8 && item.createdby == userid ?
                                                    <>
                                                   
                                                    <IconButton onClick={() => handleEditClick(item)}>
                                                        <EditIcon>

                                                        </EditIcon>
                                                    </IconButton>
                                                 
                                                    </>
                                                    :
                                                    <>
                                                    </>
                                                    }
                                                    {
                                                        item.isWarning == true && item.paytype != 'CLAIM' && currentstatus != 5 ?
                                                        <>
                                                        <IconButton onClick={() => handleModalHistoryOpen(item)}>
                                                        <WarningAmberIcon style={{color : "red"}}></WarningAmberIcon>
                                                        </IconButton>
                                                        
                                                        </>
                                                        :
                                                        item.paytype != 'CLAIM' && currentstatus != 5 && item.history.length > 0 ?
                                                        <>
                                                        <IconButton onClick={() => handleModalHistoryOpen(item)}>
                                                        <HistoryIcon style={{color : "#006633"}}></HistoryIcon>
                                                        </IconButton>
                                                        </>
                                                        :
                                                        <>
                                                        </>
                                                    }
                                                   
                                                    </div>
                                                   
                                                    <small style={{display:"inline-grid", width:"20%",justifyContent:"end"}}>
                                                   <div style={{display:"inline-flex",justifyContent:"end"}}>
                                                    <a  onClick={() => handleListClick(item,1)}>{item.totalamount.toLocaleString(undefined, {maximumFractionDigits:2})}</a>
                                                    {item.isOpen ?
                                                    <ExpandLess onClick={() => handleListClick(item,1)} /> 
                                                    : 
                                                    <ExpandMore onClick={() => handleListClick(item,1)}/>}
                                                    </div>
                                                    {/* {
                                                        item.lastamount > 0 ?
                                                        <>
                                                        <div style={{display:"inline-flex",justifyContent:"end"}}>
                                                        <br/>
                                                        <a style={{fontSize:"11px", color: item.isWarning == true ? "red" : ""}}> Last Trans : {item.lastamount.toLocaleString(undefined, {maximumFractionDigits:2})}</a>
                                                        </div>
                                                        <div style={{display:"inline-flex",justifyContent:"end"}}>
                                                        <br/>
                                                        <a style={{fontSize:"11px", color: item.isWarning == true ? "red" : ""}}> {moment.unix(item.lastpaydate).format("DD-MMMM-YYYY")}</a>
                                                        </div>
                                                        </>
                                                        :
                                                        <>
                                                        </>
                                                    }
                                                     */}
                                                    </small>
                                                    
                                            </div>
                                                
                                            {/* </ListItemButton> */}
                                            <CollapseMUI in={item.isOpen} timeout="auto" unmountOnExit>
                                                {/* <List component="div" disablePadding>
                                                <ListItemButton sx={{ pl: 4 }}>
                                                    <ListItemText primary={item.description} />
                                                </ListItemButton>
                                                </List> */}
                                                <List component="div">
                                               
                                                    <div>{showAttachmentList(item)}</div>
                                                <br/>
                                                <Row style={{lineHeight:"0.8"}}>
                                                    <Col style={{width:"90px"}}>
                                                        <div>
                                                            <span style={{color:"black",backgroundColor:"lightblue"}}>
                                                            {`Description : `}  
                                                            </span>
                                                        
                                                        </div>
                                                    </Col>
                                                    <Col >
                                                        <div>
                                                            <Paragraph  className="textparagraph">{item.description}</Paragraph>
                                                        </div>
                                                </Col>
                                                </Row>
                                                <br/>
                                                <Row style={{lineHeight:"0.8"}}>
                                                    <Col style={{width:"90px"}}>
                                                        <div >
                                                            <span style={{color:"black",backgroundColor:"lightblue"}}>
                                                            {`Remarks : `}    
                                                            </span>
                                                        
                                                        </div>
                                                    </Col>
                                                    <Col >
                                                        <div>
                                                            <Paragraph  className="textparagraph">{item.remarks}</Paragraph>
                                                        </div>
                                                </Col>
                                                </Row>
                                                <br/>

                                                <TableContainer component={Paper}>
                                                    <TableMUI  aria-label='Header Text'>
                                                        <TableHead>
                                                            <TableRow  sx={{
                                                                    padding: "0px 0px",
                                                                    borderRight: "2px solid black",
                                                                    backgroundColor: "lightblue",
                                                                    fontSize: "1.2rem"
                                                                    
                                                                }}>
                                                                <TableCell>Item Type</TableCell>
                                                                <TableCell>Description</TableCell>
                                                                <TableCell>Qty</TableCell>
                                                                <TableCell>Price / Unit</TableCell>
                                                                <TableCell>Subtotal</TableCell>
                                                                {/* <TableCell>Pay Date</TableCell>
                                                                <TableCell>Created By</TableCell> */}
                                                                {/* <TableCell>Attachements</TableCell> */}
                                                                {/* <TableCell>Last Payment</TableCell> */}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {datasourceDetail.map((row) =>
                                                            <TableRow
                                                                key={row.Did}
                                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                                <TableCell component="th" scope="row">{row.Ditemtype}</TableCell>
                                                                <TableCell>{row.Ddescription}</TableCell>
                                                                <TableCell>{row.Dqty.toLocaleString(undefined, {maximumFractionDigits:2})}</TableCell>
                                                                <TableCell>{row.Dpriceunit.toLocaleString(undefined, {maximumFractionDigits:2})}</TableCell>
                                                                <TableCell>{row.Dtotalprice.toLocaleString(undefined, {maximumFractionDigits:2})}</TableCell>
                                                                {/* <TableCell>{moment.unix(row.pdate).format("MMM-DD")}</TableCell>
                                                                <TableCell>{row.createdby}</TableCell> */}
                                                                {/* <TableCell align='center'>
                                                                    {row.pfilelist.length > 0 ?
                                                                    <a onClick={(val) => Fopendetailupload2(row)}>
                                                                    {row.pfilelist.length}
                                                                    </a>
                                                                    :
                                                                    <span>
                                                                        -
                                                                    </span>
                                                                    } 
                                                                    
                                                                </TableCell> */}
                                                                {/* <TableCell>2022-12-29 <br/> 5,000</TableCell> */}
                                                            </TableRow>
                                                            
                                                            )}
                                                            {/* <TableRow>
                                                                <TableCell colSpan={2}>Total :</TableCell>
                                                                <TableCell align="right">{datasourceDetailTotal.toLocaleString(undefined, {maximumFractionDigits:2})}</TableCell>
                                                            </TableRow> */}
                                                        </TableBody>
                                                    </TableMUI>
                                                </TableContainer>  
                                                </List>
                                                
                                            </CollapseMUI>
                                            </>
                                            }
                                            />
                                        </List.Item>
                                    )}
                                    >

                                        
                                    </List>
                                    </>
                                }
                                    
                            </div>
                        
                      
                       </>
                   }
              
               </div>
           </Row> 
    <Modal
     destroyOnClose={true}
     title={GetTranslation(userlang,"Detail Items")}
     visible={modalVisiblePayCreate}
    //  onOk={}
     onCancel={() => handleDetailListingClose()}
    footer={[
        <Button key="back" onClick={() => handleDetailListingClose()}>
          Return
        </Button>
      ]}
     width={"90%"}
    >
        <Row>
            <Autocomplete 
            value={Ditemtype}
            onChange={(val1,val2) => Ditemtypechange(val2)}
            options={Maccoutitems}
            isOptionEqualToValue={(option, value) => option.label === value}
            style={{width:"100%"}}
            renderInput={(params) => <TextField {...params} label="Item Type" />}>
            
            </Autocomplete>
        </Row>
        <br/>
        <Row>
            <div style={{width:"100%"}}>
                <TextField
                style={{width:"100%"}}
                id="outlined-remark"
                label="Description"
                value={Ddescription}
                onChange={(val1) => setDdescription(val1.target.value)}
                multiline
                InputLabelProps={{
                    shrink: true,
                }}
                />
            </div>
        </Row>
        <br/>
        <Row>
            <div style={{width:"100%"}}>
                <TextField
                style={{width:"100%"}}
                id="outlined-remark"
                label="Quantity"
                value={Dqty}
                onChange={(val1) => setDqty(val1.target.value)}
                type="number"
                InputLabelProps={{
                    shrink: true,
                }}
                />
            </div>
        </Row>
        <br/>
        <Row>
            <div style={{width:"100%"}}>
                <TextField
                style={{width:"100%"}}
                id="outlined-remark"
                label="Price / Unit"
                value={Dpriceunit}
                type="number"
                onChange={(val1) => setDpriceunit(val1.target.value)}
                InputLabelProps={{
                    shrink: true,
                }}
                />
            </div>
        </Row>
        <Row>
            <div style={{width:"100%",display:"flex",justifyContent:"center"}}>
                <IconButton size='large' onClick={(val1) => addDetailListing()} style={{color:"green"}}>
                    <AddCircleOutlineIcon />
                </IconButton>
            </div>
        </Row>
        <Row>
        <TableContainer component={Paper}>
            <TableMUI  aria-label='Header Text'>
                <TableHead>
                    <TableRow>
                        <TableCell></TableCell>
                        <TableCell>Item Type</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell>Quantity</TableCell>
                        <TableCell>Price / Unit</TableCell>
                        <TableCell>Subtotal Price</TableCell>
                        {/* <TableCell>Attachements</TableCell> */}
                        {/* <TableCell>Last Payment</TableCell> */}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {Cdetailitemslist.map((row) =>
                    <TableRow
                        key={row.Did}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell><IconButton onClick={(val1) => RemoveDetailItemsList(row.Did)}><DeleteForeverIcon style={{color:"red"}}></DeleteForeverIcon></IconButton></TableCell>
                        <TableCell component="th" scope="row">{row.Ditemtype}</TableCell>
                        <TableCell>{row.Ddescription}</TableCell>
                        <TableCell>{row.Dqty.toLocaleString(undefined, {maximumFractionDigits:2})}</TableCell>
                        <TableCell>{row.Dpriceunit.toLocaleString(undefined, {maximumFractionDigits:2})}</TableCell>
                        <TableCell>{row.Dtotalprice.toLocaleString(undefined, {maximumFractionDigits:2})}</TableCell>
                        {/* <TableCell align='center'>
                            {row.pfilelist.length > 0 ?
                            <a onClick={(val) => Fopendetailupload2(row)}>
                            {row.pfilelist.length}
                            </a>
                            :
                            <span>
                                -
                            </span>
                            } 
                            
                        </TableCell> */}
                        {/* <TableCell>2022-12-29 <br/> 5,000</TableCell> */}
                    </TableRow>
                    
                    )}
                     {/* <TableRow>
                         <TableCell colSpan={2}>Total :</TableCell>
                         <TableCell align="right">{datasourceDetailTotal.toLocaleString(undefined, {maximumFractionDigits:2})}</TableCell>
                     </TableRow> */}
                </TableBody>
            </TableMUI>
        </TableContainer>  
        </Row>
    </Modal>

    <Modal
     destroyOnClose={true}
     title={GetTranslation(userlang,"Detail Listing")}
     visible={modalVisibleDetailList}
    //  onOk={}
     onCancel={() => handleModalDetailListClose(false)}
     footer={[
        <Button key="back" onClick={() => handleModalDetailListClose(false)}>
          Return
        </Button>,
       
      ]}
     width={"100%"}
    >
        <Row style={{lineHeight:"0.8"}}>
            <Col style={{width:"90px"}}>
                <div>
                    <span style={{color:"black",backgroundColor:"lightblue"}}>
                    {`Description : `}  
                    </span>
                </div>
            </Col>
            <Col >
                <div>
                    <Paragraph  className="textparagraph">{datasourceDetailHeader.description}</Paragraph>
                </div>
           </Col>
        </Row>
        <br/>
        <Row style={{lineHeight:"0.8"}}>
            <Col style={{width:"90px"}}>
                <div >
                    <span style={{color:"black",backgroundColor:"lightblue"}}>
                    {`Remarks : `}    
                    </span>
                   
                </div>
            </Col>
            <Col >
                <div>
                    <Paragraph  className="textparagraph">{datasourceDetailHeader.remarks}</Paragraph>
                </div>
           </Col>
        </Row>
        <br/>
      
        
    </Modal>

    <Modal
        visible={previewIconVisible}
        footer={null}
        onCancel={handleIconPreviewCancel}
        >
            <img alt="" style={{ width: '100%' }} src={previewIconImage} />
        </Modal>
        <Modal
        visible={previewDetailFileList}
        title={DetailAttachHeader}
        footer={null}
        onCancel={handleDetailCancel}
        >
           <Upload {...PaymentDetailAttProps}>
           <Button icon={<UploadOutlined />}>Upload</Button>
           </Upload>
        </Modal>
        <Modal
        visible={previewDetailFileList2}
        title={DetailAttachHeader}
        footer={null}
        onCancel={handleDetailCancel2}
        >
           <Upload {...PaymentDetailAttProps}>
           </Upload>
        </Modal>

        <Modal
        visible={modalVisibleHistory}
        title={modalHistoryHeader}
        footer={null}
        width={"100%"}
        onCancel={handleModalHistoryClose}
        >
          <TableContainer component={Paper}>
            <TableMUI  aria-label='Header Text'>
                <TableHead>
                    <TableRow sx={{
                            backgroundColor: "powderblue",
                            borderBottom: "2px solid black",
                            "& th": {
                            fontSize: "1.25rem",
                            color: "rgba(96, 96, 96)"
                            }
                        }}>
                        <TableCell>Last Update Date</TableCell>
                        <TableCell>Title</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell>Total Amount</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Create Date</TableCell>
                        <TableCell>Create By</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {datasourceHistrory.map((row) =>
                    <TableRow
                        key={row.Did}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } ,backgroundColor : row.totalamount == CurrentTotalAmount ? "gold" :"" }}>
                        <TableCell component="th" scope="row">{moment.unix(row.updatedte).format("DD-MMMM-YYYY")}</TableCell>
                        <TableCell>{row.title}</TableCell>
                        <TableCell>{row.description}</TableCell>
                        <TableCell>{row.totalamount.toLocaleString(undefined, {maximumFractionDigits:2})}</TableCell>
                        <TableCell> {row.status == 0 ? 'Pending Approval': 
                                    row.status == 1 ? 'Pending Verify': 
                                    row.status == 2 ? "Ready To Issue" :
                                    row.status == 3 ? "Waiting To Complete": 
                                    row.status == 4 ? 'Completed': 
                                    row.status == 8 ? 'Rejected': 
                                    row.status == 9 ? 'Canceled' : ''
                    }</TableCell>
                    <TableCell>{moment.unix(row.createddate).format("DD-MMMM-YYYY")}</TableCell>
                    <TableCell >{FULLuserLists.filter(x => x._id == row.createdby) ? FULLuserLists.filter(x => x._id == row.createdby)[0].userid + '('+ FULLuserLists.filter(x => x._id == row.createdby)[0].markingcode+')' : "Error"}</TableCell>
                    </TableRow>
                    
                    )}
                     {/* <TableRow>
                         <TableCell colSpan={2}>Total :</TableCell>
                         <TableCell align="right">{datasourceDetailTotal.toLocaleString(undefined, {maximumFractionDigits:2})}</TableCell>
                     </TableRow> */}
                </TableBody>
            </TableMUI>
        </TableContainer>  
        </Modal>

        <Dialog open={opendialog} onClose={handleDialogClose}>
        <DialogTitle>Alert Payments !!!</DialogTitle>
        <DialogContent>
          <DialogContentText>
           <span>This month already create  <a onClick={(val) => handleDialogOpen()}>{dialogtitle}</a> records in <span style={{color:"red"}}>{Ctype}</span>!</span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => handleDialogClose()}>Cancel</Button>
          <Button type='primary' onClick={(e) => CreatePayment(1)}>Create</Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openUpdatedialog} onClose={handleDialogClose}>
        {/* <DialogTitle>Update Status</DialogTitle> */}
        <DialogContent>
          <DialogContentText>
              {
                  currentstatus == 2 ?
                  <>
                   <span> Payment ID : <span style={{color:"red"}}>{Ipayid}</span></span>
                   <br/>
                  </>
                  :
                  <>
                  </>
              }
           <span> Payment Selected : <span style={{color:"red"}}>{dialogUpdateDetailCount}</span>
           <br/> Total Amount : <span style={{color:"red"}}>{dialogUpdateDetailAmount}</span></span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => handleDialogClose()}>Cancel</Button>
          <Button type='primary' onClick={(val) => UpdatePaymentStatus(dialogUpdateDetailStatus,"",1)}>{dialogUpdatedetailbutton}</Button>
        </DialogActions>
      </Dialog>
      <Snackbar 
      anchorOrigin={{ vertical: "top", horizontal: "center" }} 
      open={opensnacksuccess} 
      autoHideDuration={6000} 
      onClose={handleSnackClose}>
        <Alert onClose={handleSnackClose} variant="filled" severity="success"  sx={{ width: '100%' }}>
          Payment create successfully !
        </Alert>
      </Snackbar>
      <Snackbar 
      anchorOrigin={{ vertical: "top", horizontal: "center" }} 
      open={opensnackfail} 
      autoHideDuration={6000} 
      onClose={handleSnackClose}>
        <Alert onClose={handleSnackClose} variant="filled" severity="error"  sx={{ width: '100%' }}>
          Payment create fail !
        </Alert>
      </Snackbar>
      <Snackbar 
      anchorOrigin={{ vertical: "top", horizontal: "center" }} 
      open={opensnackerror} 
      autoHideDuration={6000} 
      onClose={handleSnackClose}>
        <Alert onClose={handleSnackClose} variant="filled" severity="error"  sx={{ width: '100%' }}>
          Error Occurs, Please Contact IT !
        </Alert>
      </Snackbar>
      <Snackbar 
      anchorOrigin={{ vertical: "top", horizontal: "center" }} 
      open={opensnackupdate} 
      autoHideDuration={6000} 
      onClose={handleSnackClose}>
        <Alert onClose={handleSnackClose} variant="filled" severity="success"  sx={{ width: '100%' }}>
          Records Updated !
        </Alert>
      </Snackbar>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={ProgressStatus}>
     
      <CircularProgress color="inherit" />
      </Backdrop>
          </>
      )
}